<template>
	<div class="tp-parentdiv d-flex">
		<div
			style="position: fixed; top: 20px; z-index: 1055; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="quesbankmain-container position-relative">
			<div class="headtext d-flex align-items-center justify-content-between">
				<div class="heading">
					<span>{{
						isCommunicationTestQB ? "Communication Test" : "Question Bank"
					}}</span>
				</div>
				<div v-if="roles.includes('PUSH_QUESTION_BANK')" class="d-flex">
					<div
						v-if="selectedQuestions.length > 0"
						class="pl-3 pr-3 qb-sel-questions mr-2 d-flex align-items-center"
					>
						Selected Questions : {{ selectedQuestions.length }}
					</div>
					<b-button
						v-if="!isCommunicationTestQB"
						class="addbtn mr-2"
						v-b-modal.excel-modal-center
						:disabled="selectedQuestions.length > 0"
						v-b-tooltip.hover
						:title="
							selectedQuestions.length > 0 ? 'Unselect Questions To Import' : ''
						"
						variant="secondary"
					>
						<img src="../../assets/plusicon.svg" alt="" class="mr-2 mb-1" />
						<span class="">Import Excel</span>
					</b-button>

					<b-button
						class="addbtn"
						@click="
							isCommunicationTestQB
								? openAddCommunicationModal()
								: $bvModal.show('modal-center')
						"
						:disabled="selectedQuestions.length > 0"
						v-b-tooltip.hover
						:title="
							selectedQuestions.length > 0 ? 'Unselect Questions To Add' : ''
						"
					>
						<img src="../../assets/plusicon.svg" alt="" class="mr-2 mb-1" />
						<span class="">Add Question</span>
					</b-button>
				</div>
			</div>

			<div
				id="filtermodal"
				v-if="filtermodalshow"
				ref="filter"
				class="qb-filter-modal-1"
				v-closable="{
					exclude: ['filter', 'filter-1'],
					handler: 'filterFunction',
				}"
			>
				<div class="qb-fm-heading p-2">
					<div @click="filterFunction" class="xMarkCancel pointer">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					Filter By
				</div>
				<div class="p-3">
					<div class="mt-3" v-if="!isCommunicationTestQB">
						<div class="relativeclass">
							<label class="fieldsetStyle">Question Type</label>
							<div
								class="qb-dropdown-diffy d-flex justify-content-between p-2 pointer"
								@click="
									(qbdrop = !qbdrop),
										(questionTagOpen = false),
										(showdiffoptions = false)
								"
							>
								<span v-if="filter.questiontype_selected.length === 0"
									>Choose Options</span
								>
								<span v-else>
									<span
										v-for="(selectedType,
										index) in filter.questiontype_selected"
										:key="index"
									>
										<span v-if="selectedType === 'MCQU'">MCQ</span>
										<span v-else-if="selectedType === 'MAFO'">MTF</span>
										<span v-else-if="selectedType === 'LONG'">DESC</span>
										<span
											v-if="index !== filter.questiontype_selected.length - 1"
											>,</span
										>
									</span>
								</span>
								<span>
									<img
										v-if="qbdrop"
										src="../../assets/uparrow.svg"
										alt=""
										class="mr-1"
									/>
									<img
										v-else
										src="../../assets/downarrow.svg"
										alt=""
										class="mr-1"
									/>
								</span>
							</div>
							<div v-if="qbdrop" class="qb-dropdown-option d-flex">
								<b-form-group class="qb-dd-group">
									<b-form-checkbox
										class="qb-dropdown-option-sing pointer m-1"
										size="sm"
										v-for="option in questiontype_options"
										:key="option.value"
										:value="option.value"
										v-model.trim="filter.questiontype_selected"
										name="flavour-4a"
									>
										{{ option.text }}
									</b-form-checkbox>
								</b-form-group>
							</div>
						</div>
					</div>

					<div
						class="topDiv mt-3"
						@click="qbdrop = false"
						v-if="!isCommunicationTestQB"
					>
						<label class="fieldsetStyle sharelabel">Marks</label>
						<b-form-input
							type="number"
							class=""
							v-model="filter.marks"
							placeholder="Marks"
							@keypress="avoidNegativeAndOutOfRange"
							min="0"
							max="100"
						></b-form-input>
					</div>
					<div class="mt-3">
						<div class="relativeclass">
							<label class="fieldsetStyle">Difficulty Level</label>
							<div
								class="qb-dropdown-diffy d-flex justify-content-between p-2 pointer"
								@click="
									(showdiffoptions = !showdiffoptions),
										(questionTagOpen = false),
										(qbdrop = false)
								"
							>
								<span v-if="filter.difficulty_type.length === 0"
									>Choose Options</span
								>
								<span v-else
									>{{ filter.difficulty_type.length }} options selected</span
								>
								<span>
									<img
										v-if="showdiffoptions"
										src="../../assets/uparrow.svg"
										alt=""
										class="mr-1"
									/>
									<img
										v-else
										src="../../assets/downarrow.svg"
										alt=""
										class="mr-1"
									/>
								</span>
							</div>
							<div v-if="showdiffoptions" class="qb-dropdown-option d-flex">
								<b-form-group class="qb-dd-group">
									<b-form-checkbox
										class="qb-dropdown-option-sing pointer m-1"
										size="sm"
										v-for="(option, index) in diffoptions"
										:key="index"
										:value="option.value"
										v-model.trim="filter.difficulty_type"
										name="flavour-4a"
									>
										{{ option.text }}
									</b-form-checkbox>
								</b-form-group>
							</div>
						</div>
					</div>
					<div
						class="mt-3"
						@click="(showdiffoptions = false), (qbdrop = false)"
					>
						<div class="relativeclass">
							<label class="fieldsetStyle">Question Tags</label>
							<div
								class="qb-dropdown-diffy d-flex justify-content-between pointer"
								@click="questionTagToggle"
							>
								<span
									class="cj-noofrecoption"
									v-if="filter.questionTags.length == 1"
								>
									{{ filter.questionTags.length }} question tag selected
								</span>
								<span
									class="cj-noofrecoption"
									v-else-if="filter.questionTags.length != 0"
								>
									{{ filter.questionTags.length }} question tags selected
								</span>
								<span class="cj-noofrecoption" v-else> Select Tag(s)..</span>
								<span>
									<img
										v-if="questionTagOpen"
										src="../../assets/uparrow.svg"
										alt=""
										class="mr-1"
									/>
									<img
										v-else
										src="../../assets/downarrow.svg"
										alt=""
										class="mr-1"
									/>
								</span>
							</div>
						</div>
						<div
							v-if="questionTagOpen == true"
							class="qb-dropdown-option-add"
							style="width: 91%"
							ref="recdropdown"
						>
							<div class="relativeclass recinput">
								<b-form-input
									class="inputField"
									type="text"
									placeholder="Search"
									v-model="searchquestiontag"
								>
								</b-form-input>
								<div class="searchicon">
									<img src="../../assets/searchicon.svg" alt="" />
								</div>
								<b-form-group class="rec-dd-group">
									<b-form-checkbox
										class="qb-dropdown-option-sing pointer m-1"
										size="sm"
										v-for="(option, index) in filterallQuestionTags"
										:key="index"
										:value="option"
										v-model.trim="filter.questionTags"
										name="flavour-4a"
									>
										{{ option }}
									</b-form-checkbox>
								</b-form-group>
								<div v-if="filterallQuestionTags.length == 0" class="mt-2">
									No question tags found
								</div>
							</div>
						</div>
					</div>

					<div class="filterMedia d-flex justify-content-between mt-3">
						<b-form-group label="Media Type" v-slot="{ ariaDescribedby }">
							<b-form-checkbox-group
								size="sm"
								v-model="selectedMediaType"
								:options="mediatypeOptions"
								:aria-describedby="ariaDescribedby"
								name="radio-inline"
							></b-form-checkbox-group>
						</b-form-group>
					</div>
					<div class="d-flex justify-content-between mt-3">
						<span
							class="clearfilter pointer mt-3"
							:class="
								clearFilterclass
									? filtercount == 0
										? 'disabled-text'
										: 'pointer'
									: 'pointer'
							"
							@click="
								clearFilterclass
									? filtercount == 0
										? clearfilterbox()
										: clearfilter()
									: filtercount == 0
									? clearfilterbox()
									: clearfilter()
							"
							>Clear filter</span
						>
						<b-button
							class="addbtn pl-2 pr-2 pt-1 pb-1"
							:disabled="clearFilterclass"
							@click="filterapply()"
						>
							<span class="">Apply</span>
						</b-button>
					</div>
				</div>
			</div>
			<template
				v-if="
					allQuestions.length == 0 &&
						total == 0 &&
						searchTopicTestState == '' &&
						filtercount == 0 &&
						LoaderStatus == false
				"
			>
				<div
					class="d-flex flex-column align-items-center justify-content-center h-100"
				>
					<div>
						<img src="../../assets/noQuestions.svg" alt="" />
					</div>
					<div class="d-flex text-center mt-2">
						<span class="searchnotfound"
							>There are no questions in the question bank.<br />
							Click on <strong> “Add Question” </strong> to start creating
							questions
						</span>
					</div>
				</div>
			</template>
			<!-- new table design starts from here -->

			<template v-else>
				<div class="question-main-table mt-2">
					<div class="question-table-head m-1">
						<div class="text-center question-first-col qb-header-checkbox">
							<template v-if="allQuestions.length !== 0">
								<b-form-checkbox
									class="qb-selectall pl-4"
									v-if="roles.includes('DELETE_QUESTION_BANK')"
									v-model="selectall"
									@change="selectAll()"
								>
								</b-form-checkbox>
							</template>
						</div>
						<div class="text-left question-second-col">Questions</div>
						<div class="text-center question-third-col">
							Marks Alloted
							<template v-if="sortColumn == 'marks'">
								<img
									@click="sort('marks')"
									v-if="sorting == true"
									src="../../assets/icons/share/ascending.svg"
									alt=""
									class="pointer"
								/>
								<img
									v-else
									@click="sort('marks')"
									src="../../assets/icons/share/descending.svg"
									alt=""
									class="pointer"
								/>
							</template>
							<img
								v-else
								@click="sort('marks')"
								src="../../assets/icons/share/nosort.svg"
								alt=""
								class="pointer"
							/>
						</div>
						<div class="text-center question-third-col">
							Difficulty Level

							<template v-if="sortColumn == 'difficultyLevel'">
								<img
									@click="sort('difficultyLevel')"
									v-if="sorting == true"
									src="../../assets/icons/share/ascending.svg"
									alt=""
									class="pointer"
								/>
								<img
									v-else
									@click="sort('difficultyLevel')"
									src="../../assets/icons/share/descending.svg"
									alt=""
									class="pointer"
								/>
							</template>
							<img
								v-else
								@click="sort('difficultyLevel')"
								src="../../assets/icons/share/nosort.svg"
								alt=""
								class="pointer"
							/>
						</div>
						<div class="text-center question-third-col">
							Created Date
							<template v-if="sortColumn == 'createdAt'">
								<img
									@click="sort('createdAt')"
									v-if="sorting == true"
									src="../../assets/icons/share/ascending.svg"
									alt=""
									class="pointer"
								/>
								<img
									v-else
									@click="sort('createdAt')"
									src="../../assets/icons/share/descending.svg"
									alt=""
									class="pointer"
								/>
							</template>
							<img
								v-else
								@click="sort('createdAt')"
								src="../../assets/icons/share/nosort.svg"
								alt=""
								class="pointer"
							/>
						</div>
						<div class="text-center question-third-col">
							<div class="d-flex align-items-center justify-content-center">
								<div class="d-flex position-relative" ref="filter-1">
									<img
										v-b-popover.hover.top="'Filter'"
										class="pointer"
										@click="modalpop()"
										src="../../assets/icons/Qpbuilder/qbfilter.svg"
										alt=""
									/>
									<div class="qb-filter-count-ex mb-3" v-if="filtercount != 0">
										{{ filtercount }}
									</div>
								</div>
								<div>
									<template v-if="allQuestions.length !== 0">
										<b-button
											v-if="roles.includes('DELETE_QUESTION_BANK')"
											variant="outline"
											class="qb-remove-padding ml-3"
											:disabled="selectedQuestions.length == 0"
											v-b-modal.modal-delete
											><img
												class="pointer"
												v-b-popover.hover.top="'Delete'"
												src="../../assets/icons/Qpbuilder/qbdelete.svg"
												alt=""
											/>
										</b-button>
									</template>
								</div>
							</div>
						</div>
					</div>
					<div class="question-table-body m-1" id="top1">
						<template
							v-if="allQuestions.length == 0 && this.LoaderStatus === false"
						>
							<div
								v-if="
									searchTopicTestState == '' && total === 0 && filtercount !== 0
								"
								class="d-flex flex-column align-items-center justify-content-center h-100"
							>
								<div>
									<img src="../../assets/searchnotfound.svg" alt="" />
								</div>
								<div>
									<span class="searchnotfound">No questions available.</span>
								</div>
							</div>

							<div
								v-if="
									searchTopicTestState != '' && searchTopicTestState != 'Loader'
								"
								class="d-flex flex-column align-items-center justify-content-center h-100"
							>
								<div>
									<img src="../../assets/searchnotfound.svg" alt="" />
								</div>
								<div class="text-center">
									<span class="searchnotfound"
										>No matching results for
										<span class="searchtext text-break">
											"{{ searchTopicTestState }}"
										</span>
									</span>
								</div>
							</div>
						</template>

						<template v-else>
							<div v-for="(i, index) in allQuestions" :key="index">
								<div class="question-table-row align-middle" v-if="!i.view">
									<div
										class="questioncolorbar-match"
										v-if="i.quesType == 'MAFO'"
									></div>
									<div
										class="questioncolorbar-mcq"
										v-if="i.quesType == 'MCQU'"
									></div>
									<div
										class="questioncolorbar-desc"
										v-if="i.quesType == 'LONG'"
									></div>
									<div
										class="questioncolorbar-comu"
										v-if="i.quesType == 'COMU'"
									></div>

									<b-form-checkbox
										v-if="roles.includes('DELETE_QUESTION_BANK')"
										name="checkboxes"
										v-model="selectedQuestions"
										:value="i.questionKey"
										@change="deselect()"
										class="text-center question-first-col"
									>
									</b-form-checkbox>
									<div class="question-second-col">
										<div class="qb-tag-name">
											<span v-if="i.quesType == 'MCQU'">MCQ</span>
											<span v-if="i.quesType == 'MAFO'">MTF</span>
											<span v-if="i.quesType == 'LONG'">DESC</span>
											<span v-if="i.quesType == 'COMU'">COMU</span>
										</div>
										<div class="question-div">
											<div v-if="i.questionMedia != null">
												<span v-if="isImage(i.questionMediaType)"
													><img src="../../assets/image.svg" alt="" />
													Image</span
												>
												<span v-if="isAudio(i.questionMediaType)"
													><img src="../../assets/audio.svg" alt="" />
													Audio</span
												>
												<span v-if="isVideo(i.questionMediaType)"
													><img src="../../assets/vedio.svg" alt="" />
													Video</span
												>
											</div>
											<div
												v-html-safe="i.question"
												class="qb-question-elipsis"
												:class="{
													'mt-3': !('questionMedia' in i),
												}"
											></div>
										</div>
									</div>

									<div class="text-center question-third-col">
										{{ i.marks }}
									</div>
									<div class="text-center question-third-col">
										{{ i.difficultyLevel }}
									</div>
									<div
										class="text-center question-third-col"
										v-if="i.createdAt != null"
									>
										{{ i.createdAt | datefilter }}
									</div>

									<div class="text-center question-third-col">
										<img
											@click="viewQuestion(index)"
											v-b-popover.hover.top="'Preview'"
											src="../../assets/viewiconn.svg"
											alt=""
											class="pointer"
										/>
										<img
											v-if="roles.includes('PUT_QUESTION_BANK')"
											@click="
												isCommunicationTestQB
													? openEditCommunQues(i)
													: editmodal(i)
											"
											v-b-popover.hover.top="'Edit'"
											src="../../assets/editicon.svg"
											alt=""
											class="pointer ml-3"
										/>
									</div>
								</div>

								<div class="question-view-card position-relative" v-else>
									<div
										class="question-tag-name-view d-flex align-items-center justify-content-center"
									>
										<span v-if="i.quesType == 'MCQU'">MCQ</span>
										<span v-if="i.quesType == 'MAFO'">MTF</span>
										<span v-if="i.quesType == 'LONG'">DESC</span>
										<span v-if="i.quesType == 'COMU'">COMU</span>
									</div>
									<div class="w-100 d-flex">
										<div style="width: 90%">
											<div class="d-flex w-100">
												<div class="d-flex mx-3">
													<div
														class="question-expand-colorbar"
														:style="cssForDynamicColor"
														style="background: var(--dynamicBorderColor)"
													></div>

													<b-form-checkbox
														v-if="roles.includes('DELETE_QUESTION_BANK')"
														name="checkboxes"
														v-model="selectedQuestions"
														:value="i.questionKey"
														@change="deselect()"
														class="mt-3"
													>
													</b-form-checkbox>

													<div class="body-second-col-div"></div>
												</div>
												<div class="qb-text-margin w-100">
													<div class="mt-1" v-if="i.questionMedia != null">
														<span
															class="d-flex"
															v-if="isImage(i.questionMediaType)"
															><img
																class="mr-1"
																src="../../assets/image.svg"
																alt=""
															/>
															Image</span
														>
														<span
															class="d-flex"
															v-if="isAudio(i.questionMediaType)"
															><img
																class="mr-1"
																src="../../assets/audio.svg"
																alt=""
															/>
															Audio</span
														>
														<span
															class="d-flex"
															v-if="isVideo(i.questionMediaType)"
															><img
																class="mr-1"
																src="../../assets/vedio.svg"
																alt=""
															/>
															Video</span
														>
													</div>
													<div class="d-flex w-100">
														<template v-if="i.questionMedia != null">
															<div
																class="question-image-container d-flex justify-content-center"
																v-if="isImage(i.questionMediaType)"
															>
																<img
																	class="w-100 h-100"
																	:src="i.questionMedia"
																	alt=""
																	style="object-fit:contain;"
																/>
															</div>
															<div
																v-if="isAudio(i.questionMediaType)"
																class="d-flex align-items-center justify-content-center"
															>
																<div class="quesbank-audioCard mt-3">
																	<img
																		class="h-100 w-100"
																		src="../../assets/icons/Qpbuilder/audioGradient.svg"
																		alt=""
																	/>
																	<Media
																		:kind="'audio'"
																		:isMuted="false"
																		:src="i.questionMedia"
																		:autoplay="false"
																		:controls="true"
																		:loop="true"
																		class="quesbankcard-audio"
																	></Media>
																	<img
																		class="quesbank-mic"
																		src="../../assets/icons/Qpbuilder/audioMic.svg"
																		alt=""
																	/>
																</div>
															</div>
															<div v-if="isVideo(i.questionMediaType)">
																<Media
																	:kind="'video'"
																	:isMuted="false"
																	:src="i.questionMedia"
																	:autoplay="false"
																	:controls="true"
																	:loop="true"
																	class="qb-image-preview"
																></Media>
															</div>
														</template>
														<div class="w-100 ml-3">
															<div
																class="quesbank-ques-text"
																v-html-safe="i.question"
															></div>
															<b-row v-if="i.quesType == 'MCQU'" class="my-2">
																<b-col
																	v-for="(option, ind) in i.options"
																	:key="ind"
																	:cols="
																		i.questionMedia != null &&
																		(isImage(i.questionMediaType) ||
																			isAudio(i.questionMediaType) ||
																			isVideo(i.questionMediaType))
																			? 4
																			: 3
																	"
																	:class="{
																		quesbankradios:
																			!i.noOfCorrectOptionsAllowed ||
																			i.noOfCorrectOptionsAllowed == 1,
																		'mt-2': ind > 0,
																	}"
																>
																	<b-form-checkbox
																		v-if="i.noOfCorrectOptionsAllowed > 1"
																		class=""
																		disabled
																		v-model="option.check"
																		><span v-if="option.value">
																			{{ option.value }}</span
																		>
																		<span v-if="option.media">
																			<span class="uploaded-option-imagecard">
																				<img
																					:src="option.media"
																					alt=""
																					class="w-100 h-100 overflow-hidden"
																					style="border-radius: 4px;"
																				/>
																			</span>
																		</span>
																	</b-form-checkbox>
																	<b-form-radio
																		v-else
																		:class="
																			option.check == true
																				? 'qb-sec-ques-green'
																				: 'qb-sec-questions-radios'
																		"
																		v-model="selected"
																		disabled
																		><span v-if="option.value">
																			{{ option.value }}</span
																		>
																		<span v-if="option.media">
																			<span class="uploaded-option-imagecard">
																				<img
																					:src="option.media"
																					alt=""
																					class="w-100 h-100 overflow-hidden"
																					style="border-radius: 4px;"
																				/>
																			</span> </span
																	></b-form-radio>
																</b-col>
															</b-row>
														</div>
													</div>

													<div class="quesbank-ques-text ">
														<b-row v-if="i.quesType == 'MAFO'">
															<b-col cols="12">
																<div
																	class="mofo-answrdiv d-flex justify-content-between"
																	v-for="(option, index) in i.answerKey"
																	:key="index"
																>
																	<div
																		class="mafo-option-text d-flex pl-2 align-items-center"
																	>
																		{{ option.sideA }}
																	</div>
																	<div
																		class="mafo-option-text ml-4 d-flex align-items-center"
																	>
																		<div
																			class="d-flex align-items-center disablesixdots"
																		>
																			<img
																				src="../../assets/disablesixdots.svg"
																				alt=""
																			/>
																		</div>
																		<div class="ml-2 d-flex align-items-center">
																			{{ option.sideB }}
																		</div>
																	</div>
																</div>
															</b-col>
														</b-row>
													</div>
													<div
														class="d-flex mt-3"
														style="width: 100%"
														v-if="i.questionTags.length > 0"
													>
														<div style="width: 80%">
															<div class="d-flex flex-wrap ml-3">
																<div
																	class="view-questags pl-2 pr-2 pt-1 pb-1 mr-2 mt-2"
																	v-for="qt in filterQuestionTags(
																		i.questionTags
																	)"
																	:key="qt"
																	v-b-popover.hover.top="qt"
																>
																	{{ qt | fnName }}
																</div>
															</div>
														</div>
														<b-input-group-append
															v-if="i.questionTags.length > 6 && questagmore"
															@click="changequestagmore()"
															style="width: 20%"
															class="text-center mt-1"
														>
															<div type="button" class="questag-more-btn">
																view more
															</div>
														</b-input-group-append>
														<b-input-group-append
															class="text-center mt-1"
															v-if="
																i.questionTags.length > 6 &&
																	questagmore == false
															"
															@click="changequestagmore()"
															tyle="width:20%"
														>
															<div type="button" class="questag-more-btn">
																view less
															</div>
														</b-input-group-append>
													</div>

													<template v-if="i.questionTags.length > 0">
														<hr class="ml-3" />
													</template>
												</div>
											</div>
											<div
												class="d-flex align-items-center"
												v-if="i.correctAnswer"
											>
												<div
													class="topDiv mt-3 ml-5 relativeclass"
													style="width: 100%"
												>
													<label class="addquesboxfieldsetStyle">
														Answer &nbsp;</label
													>
													<b-form-textarea
														class="sec-ques-style overflow-auto"
														disabled
														v-model="i.correctAnswer"
														placeholder="Enter something..."
														rows="3"
														max-rows="6"
													></b-form-textarea>
												</div>
											</div>

											<div
												class="d-flex justify-content-around mb-2 mt-2 new-margin"
											>
												<div class="d-flex align-items-center">
													<div class="quesbank-number-text">
														Marks Alloted :
													</div>

													<div class="ques-new-text ml-2">
														{{ i.marks }}
													</div>
												</div>

												<div class="d-flex align-items-center">
													<div class="quesbank-number-text">
														Difficulty Level :
													</div>

													<div class="ques-new-text ml-2">
														{{ i.difficultyLevel }}
													</div>
												</div>

												<div class="d-flex align-items-center">
													<div class="quesbank-number-text">Created Date :</div>

													<div
														class="quesbank-number-text ml-2"
														v-if="i.createdAt != null"
													>
														{{ i.createdAt | datefilter }}
													</div>
												</div>

												<div class="d-flex align-items-center">
													<div class="quesbank-number-text">
														Modified Date :
													</div>

													<div
														class="quesbank-number-text ml-2"
														v-if="i.updatedAt != null"
													>
														{{ i.updatedAt | datefilter }}
													</div>
												</div>
											</div>
										</div>

										<div
											class="d-flex align-items-start justify-content-start"
											style="width: 10%"
										>
											<div class="d-flex justify-content-evenly mt-3">
												<img
													@click="closeViewQuestion(index)"
													v-b-popover.hover.top="'Close Preview'"
													src="../../assets/notviewicons.svg"
													alt=""
													class="pointer ml-4"
												/>
												<img
													v-if="roles.includes('PUT_QUESTION_BANK')"
													@click="
														isCommunicationTestQB
															? openEditCommunQues(i)
															: editmodal(i)
													"
													src="../../assets/editicon.svg"
													alt=""
													class="pointer ml-4 mr-3"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>

					<div
						class="qbpaginaTion d-flex justify-content-between align-items-center"
					>
						<div class="d-flex">
							<span class="qb-gotopage-text p-1">Go to Page</span>

							<b-form-input
								type="text"
								class="qb-pagination-num mr-1"
								v-model.trim="goToPage"
								@keypress="allowNumbers($event)"
								@keyup.enter="
									goToPage === null || goToPage == '' || !isValidPage
										? ''
										: goToPageNo(goToPage)
								"
							></b-form-input>

							<b-button
								:disabled="goToPage === null || goToPage == '' || !isValidPage"
								class="qb-pagination-addbtn"
								@click="goToPageNo(goToPage)"
							>
								<span
									><img src="../../assets/whiterightarrow.svg" alt=""
								/></span>
							</b-button>
						</div>

						<div class="pagination">
							<b-pagination
								v-model.number="currentPage"
								@input="goToPageNum()"
								:total-rows="total"
								:per-page="question_count"
								align="center"
								first-number
								last-number
							>
								<template #prev-text
									><span><img src="../../assets/leftvector.svg" alt="" /> </span
								></template>

								<template #next-text
									><span><img src="../../assets/rightarrow.svg" alt=""/></span
								></template>
							</b-pagination>
						</div>

						<div class="qb-gotopage-text mr-2">
							Results : <span v-if="pageStart > total">0</span
							><span v-else>{{ pageStart }}</span> - {{ pageEnd }}

							<span class="pl-1"></span> of <span class="pr-1"></span
							>{{ total }}
						</div>
					</div>
				</div>
			</template>

			<b-modal
				id="modal-center"
				centered
				hide-footer
				hide-header
				@show="resetAddQuestionModal"
				@hidden="resetAddQuestionModal"
				class="qb-add-ques-modal"
				no-stacking
				no-close-on-backdrop
			>
				<div class="">
					<div @click="killaddquestionmodal()" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<div class="modalheading">Add Question</div>
					<div class="topDiv mt-5">
						<label class="fieldsetStyle sharelabel"
							>Question Type<span class="asterik">*</span></label
						>
						<div
							class="qb-dropdown-diffy d-flex justify-content-between pointer"
							@click="qbdropadd = !qbdropadd"
						>
							<span v-if="addquestion == ''">Choose Options</span>
							<span v-if="addquestion == 'MCQ'">Multiple Choice Question</span>
							<span v-if="addquestion == 'MTF'">Match the Following</span>
							<span v-if="addquestion == 'Descriptive'">Descriptive</span>
							<span>
								<img
									v-if="qbdropadd"
									src="../../assets/uparrow.svg"
									alt=""
									class="mr-1"
								/>
								<img
									v-else
									src="../../assets/downarrow.svg"
									alt=""
									class="mr-1"
								/>
							</span>
						</div>
						<div v-if="qbdropadd" class="qb-dropdown-option-add w-100 d-flex">
							<b-form-group class="qb-dd-group">
								<b-form-radio-group
									@change="qbdropadd = !qbdropadd"
									class="qb-add-drop width-full"
									id="btn-radios-3"
									v-model="addquestion"
									:options="addquestiontype_options"
									name="radio-btn-stacked"
									buttons
									stacked
								></b-form-radio-group>
							</b-form-group>
						</div>
					</div>
					<div class="d-flex justify-content-end">
						<b-button
							class="addbtn mt-5"
							:disabled="addquestion == ''"
							@click="addQuestion()"
						>
							<span class="pl-2 pr-2 pt-1 pb-1">Add</span>
						</b-button>
					</div>
				</div>
			</b-modal>
			<!-- Add questions Modal Ends -->

			<!-- Pass and Failed Question Model Start -->
			<b-modal
				id="delete-pass-fail"
				size="xl"
				centered
				hide-footer
				hide-header
				class="p-0 jddetailsmodal"
				no-close-on-backdrop
			>
				<div
					class="page-heading justify-content-between align-items-center p-2"
				>
					<div class="jd-modal-heading d-flex justify-content-between">
						<div class="del-ques-status">Failed to Delete Questions</div>

						<div>
							<b-button
								variant="outline"
								class="qb-remove-padding ml-2"
								:disabled="selectedFailQuestions.length == 0"
								@click="failedDeleteQuestion()"
							>
								<img
									class="pointer"
									v-b-popover.hover.top="'Delete'"
									src="../../assets/icons/Qpbuilder/delete-fail.svg"
									alt=""
								/>
							</b-button>
						</div>
					</div>
					<hr />
				</div>
				<div class="xMarkCancel">
					<img
						@click="$bvModal.hide('delete-pass-fail')"
						src="../../assets/xmark.svg"
						alt=""
					/>
				</div>
				<div class="deleted-main-container">
					<div class="failedQuestion" v-for="(i, index) in force" :key="index">
						<div class="mcq-top-card">
							<span v-if="i.questionType == 'MCQU'"> MCQ </span>
							<span v-if="i.questionType == 'MAFO'"> MTF </span>
							<span v-if="i.questionType == 'LONG'"> DESC </span>
						</div>
						<div class="d-flex justify-content-between">
							<div class="qb-dynamicGrid mr-1"></div>
							<div class="failQuestionCheckbox">
								<b-form-checkbox
									name="checkbox"
									v-model="selectedFailQuestions"
									:value="{
										questionKey: i.questionKey,
										testIDs: i.testIDs,
									}"
								>
								</b-form-checkbox>
							</div>
							<div
								class="failedQuestionData qb-question-elipsis ml-1"
								style="width: 80%"
								v-html-safe="i.question"
							></div>
							<hr />
							<div style="width: 15%">
								<span class="taggedTo">Tagged To : </span>
								<span
									class="taggedTestData pointer"
									@click="previewData(index)"
								>
									{{ i.testCount }} Test(s)
								</span>
							</div>
						</div>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="preview-failed-modal"
				size="md"
				centered
				hide-footer
				hide-header
				class=""
				no-close-on-backdrop
			>
				<div class="jd-modal-heading">
					<span class="question-tagged">Question Tagged To</span>
				</div>
				<hr />
				<div>
					<div class="d-flex justify-content-end Preview-heading">
						<span> Total Tests : {{ failedTests.testCount }}</span>
					</div>
				</div>
				<div class="tagged-test-qb">
					<div
						class="Preview-box mt-2"
						v-for="(i, index) in failedTests.tests"
						:key="index"
					>
						<div class="xMarkCancel">
							<img
								@click="$bvModal.hide('preview-failed-modal')"
								src="../../assets/xmark.svg"
								alt=""
							/>
						</div>
						<div>
							<div class="failed-questions-preview">
								<div class="Preview-heading">Topic Name</div>
								<div class="Preview-data">
									{{ i.topicName }}
								</div>
							</div>
							<div class="overflow">
								<div class="Preview-heading">Tagged Tests are :</div>

								<div class="mt-1 test-name">{{ i.testName }}</div>
								<hr />
							</div>
						</div>
					</div>
				</div>
				<div class="d-flex align-items-center justify-content-end mt-3">
					<b-button
						class="addbtn"
						@click="$bvModal.hide('preview-failed-modal')"
						>Okay</b-button
					>
				</div>
			</b-modal>

			<!-- Upload Excel Modal Starts -->
			<b-modal
				id="excel-modal-center"
				centered
				hide-footer
				hide-header
				@show="removeExcelFromPopUp"
				@hidden="removeExcelFromPopUp"
				class="qb-add-ques-modal"
				no-stacking
				no-close-on-backdrop
			>
				<div class="">
					<div class="">
						<div
							@click="$bvModal.hide('excel-modal-center')"
							class="xMarkCancel"
						>
							<img src="../../assets/xmark.svg" alt="" />
						</div>
						<div class="modalheading">Import Excel</div>
						<div class="d-flex justify-content-center align-items-center mt-3">
							<input
								ref="excel-upload-input"
								class="excel-upload-input"
								type="file"
								accept=".xlsx, .xls, .xlsm"
								@change="handleClick"
							/>

							<b-button @click="handleUpload" class="addbtn mr-2 pl-2 pr-2">
								<img
									src="../../assets/icons/uploadexcel/uploadicon.svg"
									alt=""
									class="mr-2 mb-1"
								/>
								<span class="">Browse excel file here</span>
							</b-button>
						</div>

						<div class="importExcel-overflow mt-2">
							<div class="uploadfile-container" v-if="excelFile != ''">
								<div
									class="d-flex justify-content-between align-items-center mt-1"
								>
									<div class="uploadfile-head-text">{{ excelFile.name }}</div>
									<div>
										<img
											src="../../assets/icons/uploadexcel/closeicon.svg"
											alt=""
											class="pointer"
											@click="removeExcelFile"
										/>
									</div>
								</div>
								<div class="mt-3 relativeclass">
									<div class="section-text-selectsheet">Select a Sheet</div>
									<div
										class="section-content d-flex justify-content-between align-items-center pointer"
										@click="showselecteddropdown = !showselecteddropdown"
									>
										<div class="sectionname">
											<div>
												<span
													class="sbox-subtext cj-noofrecoption"
													v-if="excelSheetNameShow != 0"
												>
													{{ excelSheetNameShow.length }} sheet selected
												</span>
												<span
													class="sbox-subtext cj-noofrecoption"
													v-if="singlesheets != ''"
												>
													1 sheet selected
												</span>
												<span
													class="sbox-subtext cj-noofrecoption"
													v-if="excelSheetNameShow == 0 && singlesheets == ''"
												>
													Choose sheets
												</span>
											</div>
										</div>

										<div v-if="showselecteddropdown" class="pointer">
											<img src="../../assets/uparrow.svg" alt="" />
										</div>

										<div
											class="pointer"
											v-else
											@click="showselecteddropdown = !showselecteddropdown"
										>
											<img
												src="../../assets/icons/uploadexcel/downarrow.svg"
												alt=""
											/>
										</div>
									</div>
								</div>
								<div class="dropdown-container" v-if="showselecteddropdown">
									<div
										class="relativeclass aoeinput height-adjustment-container"
									>
										<div class="aoesearchicon-pos">
											<img
												src="../../assets/icons/uploadexcel/inputsearch.svg"
												alt=""
											/>
										</div>
										<b-form-input
											class="inputField"
											type="search"
											placeholder="Search"
											v-model="searchexcelsheets"
										>
										</b-form-input>
										<div v-if="excelFile != '' && excelSheetName.length > 0">
											<b-form-group class="qb-dd-group">
												<b-form-checkbox
													class="qb-dropdown-option-sing pointer"
													size="sm"
													v-model="excelSheetNameShow"
													v-for="option in excelSheetNamesearch"
													:key="option"
													:value="option"
												>
													{{ option }}
												</b-form-checkbox>
											</b-form-group>
										</div>
										<div v-if="excelFile != '' && singlesheets != ''">
											<b-form-group class="qb-dd-group">
												<b-form-checkbox
													class="qb-dropdown-option-sing pointer"
													size="sm"
													v-model="checked"
												>
													{{ singlesheets }}
												</b-form-checkbox>
											</b-form-group>
										</div>

										<div
											v-if="
												searchexcelsheets !== '' &&
													!excelSheetNamesearch.some((option) =>
														option
															.toLowerCase()
															.includes(searchexcelsheets.toLowerCase())
													)
											"
											class="text-center mt-2 mb-2"
										>
											<span class="searchnotfound"
												>No matching results for
												<span class="searchtext text-break">
													"{{ searchexcelsheets }}"
												</span>
											</span>
										</div>
									</div>
								</div>
							</div>
							<div
								v-if="
									excelFile != '' &&
										(excelSheetNameShow.length > 0 || singlesheets != '')
								"
								class="modalheading mt-2"
							>
								Selected sheets
							</div>

							<div
								v-if="excelFile != '' && excelSheetNameShow.length > 0"
								:class="
									!showselecteddropdown
										? 'slectedsheet-container-forDropdown'
										: 'slectedsheet-container'
								"
								class="mt-2"
							>
								<div
									class="selectedsheet-box d-flex justify-content-between align-items-center"
									v-for="(i, index) in excelSheetNameShow"
									:key="index"
								>
									<div class="sbox-subtext">{{ i }}</div>
									<div>
										<img
											src="../../assets/icons/uploadexcel/singlecross.svg"
											alt=""
											class="pointer"
											@click="removeSheet(index)"
										/>
									</div>
								</div>
							</div>

							<div
								v-if="excelFile != '' && singlesheets != ''"
								:class="
									!showselecteddropdown
										? 'slectedsheet-container-forDropdown'
										: 'slectedsheet-container'
								"
								class="mt-2"
							>
								<div
									class="selectedsheet-box d-flex justify-content-between align-items-center"
								>
									<div class="sbox-subtext">{{ singlesheets }}</div>
									<div>
										<img
											src="../../assets/icons/uploadexcel/singlecross.svg"
											alt=""
											class="pointer"
											@click="removeSheet(index)"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="mt-4 d-flex justify-content-between">
						<div>
							<b-button
								variant="outline"
								class="cursor-pointer p-2"
								@click="download()"
							>
								<span
									><img
										src="../../assets/icons/uploadexcel/downloadicon.svg"
										alt=""
								/></span>
								<span class="ml-2 qb-add-more-matches">Download Template</span>
							</b-button>
						</div>
						<div class="">
							<b-button
								variant="out-second view-feedbtn ml-1"
								squared
								@click="$bvModal.hide('excel-modal-center'), removeExcelFile()"
								>Cancel
							</b-button>
							<b-button
								:disabled="
									excelFile == '' ||
										(excelSheetNameShow.length == 0 && this.singlesheets == '')
								"
								class="addbtn ml-3 pr-3 pl-3"
								@click="acceptExcel()"
								>Upload</b-button
							>
						</div>
					</div>
				</div>
			</b-modal>
			<!-- Upload Excel Modal Ends -->

			<!-- file upload modal for mcq-->
			<b-modal
				id="attachdocs"
				centered
				hide-footer
				hide-header
				@show="resetModalMCQ"
				@hidden="resetModalMCQ"
			>
				<div @click="closeattachdocsmodal()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<div class="relativeclass sec-attachdocs">
					<div class="dot-main">
						<div
							class="d-flex align-items-center justify-content-center flex-column"
						>
							<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
								<div>
									<label for="file-upload" class="custom-file-upload pointer">
										<div class="d-flex flex-column align-items-center">
											<img
												src="../../assets/icons/Qpbuilder/uploadicon.svg"
												alt=""
											/>
											Click to browse or drag <br />and drop your files
										</div>
									</label>
									<input
										id="file-upload"
										type="file"
										@change="previewFileMCQ"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-modal>

			<!-- file upload modal for mcq -->
			<!-- file upload modal for match-->
			<b-modal
				id="attachdocs-match"
				centered
				hide-footer
				hide-header
				@show="resetModalMatch"
				@hidden="resetModalMatch"
			>
				<div @click="closeattachdocsmatchmodal()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<div class="relativeclass sec-attachdocs">
					<div class="dot-main">
						<div
							class="d-flex align-items-center justify-content-center flex-column"
						>
							<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
								<div>
									<label for="file-upload" class="custom-file-upload pointer">
										<div class="d-flex flex-column align-items-center">
											<img
												src="../../assets/icons/Qpbuilder/uploadicon.svg"
												alt=""
											/>
											Click to browse or drag <br />and drop your files
										</div>
									</label>
									<input
										id="file-upload"
										type="file"
										@change="previewFileMatch"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-modal>

			<!-- file upload modal for match -->
			<!-- file upload modal for long -->
			<b-modal
				id="attachdocs-desc"
				centered
				hide-footer
				hide-header
				@show="resetModalDescriptive"
				@hidden="resetModalDescriptive"
			>
				<div @click="closeattachdocsdescmodal()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<div class="relativeclass sec-attachdocs">
					<div class="dot-main">
						<div
							class="d-flex align-items-center justify-content-center flex-column"
						>
							<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
								<div>
									<label for="file-upload" class="custom-file-upload pointer">
										<div class="d-flex flex-column align-items-center">
											<img
												src="../../assets/icons/Qpbuilder/uploadicon.svg"
												alt=""
											/>
											Click to browse or drag <br />and drop your files
										</div>
									</label>
									<input
										id="file-upload"
										type="file"
										@change="previewFileDesc"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-modal>

			<b-modal
				id="modal-delete"
				centered
				hide-footer
				hide-header
				class="qb-add-ques-modal"
			>
				<div
					class="modalheading d-flex align-items-center justify-content-between"
				>
					Caution !
					<img class="pr-3" src="../../assets/caution.svg" alt="" />
				</div>
				<div @click="killmodaldelete()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<hr />
				<div class="mt-3 caution-modal-text">
					<span>Are you sure you want to delete ?</span>
				</div>
				<div class="normaltext">
					<span class="asterik">*</span
					><span>Please note this action cannot be undone</span>
				</div>
				<div class="d-flex align-items-center justify-content-end mt-3">
					<b-button class="addbtn" @click="deleteQuestions()">Delete</b-button>
				</div>
			</b-modal>
			<!-- Delete question  Modal Ends -->
			<!--force Delete question  Modal Starts -->
			<b-modal
				id="force-delete"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
			>
				<div
					class="modalheading d-flex align-items-center justify-content-between"
				>
					Caution !
					<img class="pr-3" src="../../assets/caution.svg" alt="" />
				</div>
				<div @click="killforcemodaldelete()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<hr />
				<div class="mt-3 caution-modal-text">
					<span
						>This question exists in {{ this.force.length }} test(s). Are you
						sure you want to delete?</span
					>
				</div>
				<div class="normaltext">
					<span class="asterik">*</span
					><span>Please note this action cannot be undone</span>
				</div>
				<div class="d-flex align-items-center justify-content-end mt-3">
					<b-button class="addbtn" @click="forcedeletequestions()"
						>Delete</b-button
					>
				</div>
			</b-modal>

			<!-- Add MCQ question Modal Starts -->
			<b-modal
				id="modal-mcq-add"
				centered
				hide-footer
				hide-header
				class="qb-add-ques-modal"
				size="lg"
				no-close-on-backdrop
				@hidden="resetMcqAddModal"
			>
				<div class="modalheading">{{ mcqQuestionStatus }} MCQ</div>
				<div @click="killaddmcqmodal()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<div :class="{ 'form-disabled': isUploadLocked }">
					<div class="qb-match-options-overflow" ref="mcqModalContent">
						<b-row>
							<b-col>
								<div class="topDiv mt-3 relativeclass">
									<label class="disabledfieldsetStyle"
										>Question Type &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										type="text"
										v-model="mcqquestion.questionType"
										class="disabledinputField"
										disabled
									></b-form-input>
								</div>
							</b-col>
							<b-col>
								<div class="qb-blue-parent topDiv mt-3 relativeclass">
									<label class="fieldsetStyle"
										>Marks &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="qb-ques-text"
										type="number"
										v-model="$v.mcqquestion.marks.$model"
										:class="{
											error: $v.mcqquestion.marks.$error || checkDec,
										}"
										min="0"
										max="100"
										@keypress="validateInput($event)"
										@input="checkDecimalMCQ"
										placeholder="Marks"
									></b-form-input>
									<div
										class="marks-delete-icon"
										v-if="
											$v.mcqquestion.marks.$dirty &&
												!$v.mcqquestion.marks.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="marks-delete-icon"
										v-if="
											!$v.mcqquestion.marks.between &&
												$v.mcqquestion.marks.required
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Should be between (0.5, 100)',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="marks-delete-icon"
										v-if="checkDec"
										v-b-popover.hover.top.v-danger="{
											content: 'Accepts only 2 digit after decimal point',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row class="questiontagcontainer">
							<b-col cols="6">
								<div class="topDiv mt-4 qb-other-textDIff">
									<label class="fieldsetStyle"
										>Difficulty Level &nbsp;<span class="asterik"
											>*</span
										></label
									>
									<div
										class="editquesdropdown d-flex justify-content-between pointer"
										@click="qbdropdiff = !qbdropdiff"
										ref="dropdiff"
										:class="{
											error: $v.mcqquestion.difficultyLevel.$error,
										}"
									>
										<span
											>Difficulty Level {{ mcqquestion.difficultyLevel }}</span
										>
										<span>
											<img
												v-if="qbdropdiff"
												src="../../assets/uparrow.svg"
												alt=""
												class="mr-1"
											/>
											<img
												v-else
												src="../../assets/downarrow.svg"
												alt=""
												class="mr-1"
											/>
										</span>
									</div>
									<div
										style="position: absolute; top: 20%; right: 10%"
										v-if="
											$v.mcqquestion.difficultyLevel.$dirty &&
												!$v.mcqquestion.difficultyLevel.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										v-if="qbdropdiff"
										v-closable="{
											exclude: ['dropdiff'],
											handler: 'hideDiffOptions',
										}"
										class="qb-dropdown-option-add-1 d-flex"
									>
										<b-form-group
											class="qb-dd-group-diff"
											v-slot="{ ariaDescribedby }"
										>
											<b-form-radio-group
												@change="qbdropdiff = !qbdropdiff"
												class="qb-add-drop width-full"
												id="btn-radios-4"
												v-model="$v.mcqquestion.difficultyLevel.$model"
												:options="options"
												:aria-describedby="ariaDescribedby"
												name="radio-btn-stacked"
												buttons
												stacked
											></b-form-radio-group>
										</b-form-group>
									</div>
								</div>
							</b-col>
							<b-col cols="6">
								<div class="qb-blue-parent topDiv mt-4 ckeditor">
									<label class="addquesboxfieldsetStyle"> Question Tags</label>
									<b-form-tags
										remove-on-delete
										v-model="mcqquestion.questionTags"
										no-outer-focus
										separator=" "
										add-on-change
									>
										<template
											v-slot="{
												tags,
												inputAttrs,
												inputHandlers,
												tagVariant,
												removeTag,
												addTag,
											}"
										>
											<b-input-group class="mb-2" id="mcqaddcontainer-tag">
												<div
													style="width: 85%"
													class="qb-transparent d-flex cust-group-input"
												>
													<div
														class="d-inline-block cust-btn-select mt-2"
														style="font-size: 1.5rem"
													>
														<b-form-tag
															v-for="tag in tags"
															@remove="removeTag(tag)"
															:key="tag"
															:title="tag"
															:variant="tagVariant"
															class="ml-1"
															>{{ tag }}</b-form-tag
														>
													</div>
													<b-form-input
														id="mcq-add-tag"
														v-bind="inputAttrs"
														v-on="inputHandlers"
														@keyup="hashtagmcqadd()"
														@keyup.enter="addTagAndResetInputMCQ()"
														@keyup.space="addTagAndResetInputMCQ()"
														@keydown.tab.prevent="addTagAndResetInputMCQ()"
														placeholder="Enter Question tag"
														style="border-bottom: unset"
														class="form-control min-width mr-4 ml-2"
														v-model="tagmodal"
													></b-form-input>
												</div>
												<b-input-group-append>
													<b-button
														:disabled="tagmodal == ''"
														@click="addTag(), (tagmodal = '')"
														variant="outline"
														class="cursor-pointer"
													>
														<img
															src="../../assets/addicongraywhite.svg"
															alt=""
														/>
													</b-button>
												</b-input-group-append>
											</b-input-group>
										</template>
									</b-form-tags>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="12">
								<div class="topDiv mt-3 relativeclass">
									<div
										:class="
											dirtyMcqQuestion ||
											(!$v.mcqquestion.question.maxLength && !dirtyMcqQuestion)
												? 'error'
												: ''
										"
									>
										<label class="addquesboxfieldsetStyle" style="z-index: 5">
											Question &nbsp;<span class="asterik">*</span></label
										>
										<QuillEditor
											:addquesProp="addquesMcq"
											:value="$v.mcqquestion.question.$model"
											@validationVal="validateText"
											@questionText="updateQuestionContent"
											@addquesBack="changedaddQues"
										>
										</QuillEditor>

										<div
											style="position: absolute; top: 5px; right: 18px"
											v-if="
												dirtyMcqQuestion && $v.mcqquestion.question.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Required',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>

										<div
											style="position: absolute; top: 5px; right: 18px"
											v-if="
												!$v.mcqquestion.question.maxLength && !dirtyMcqQuestion
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 10000 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
									<div class="media-box mt-2 align-items-center">
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="d-flex align-items-center">
												<div class="media-text ml-3">Add Media</div>
												<div class="ml-2">
													<img src="../../assets/vertical-line.svg" alt="" />
												</div>
												<div class="d-flex align-items-center ml-2 mt-1">
													<div
														class="ml-2"
														v-b-tooltip.hover="{ variant: 'secondary' }"
														title=" Audio supported formats are: wav, mp3"
													>
														<label for="file-upload" class="pointer">
															<img src="../../assets/headphone.svg" alt="" />
														</label>
														<input
															id="file-upload"
															type="file"
															accept="audio/*"
															@change="previewFileMCQ"
														/>
													</div>
													<div
														class="ml-3"
														v-b-tooltip.hover="{ variant: 'secondary' }"
														title=" Video supported formats is: mp4"
													>
														<label for="file-upload-video" class="pointer">
															<img src="../../assets/videocam.svg" alt="" />
														</label>
														<input
															id="file-upload-video"
															type="file"
															accept="video/*"
															@change="previewFileMCQ"
														/>
													</div>
													<div
														class="ml-3"
														v-b-tooltip.hover="{ variant: 'secondary' }"
														title="Image supported formats are: jpg, jpeg, png"
													>
														<label for="file-upload-image" class="pointer">
															<img
																src="../../assets/image-capture.svg"
																alt=""
															/>
														</label>
														<input
															id="file-upload-image"
															type="file"
															accept="image/*"
															@change="previewFileMCQ"
														/>
													</div>
												</div>
											</div>
											<div
												class="d-flex align-items-center"
												v-if="mcqquestion.isFailed == true"
											>
												<img
													src="../../assets/Vector.svg"
													alt=""
													class="mr-2"
												/>
												<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
											</div>
										</div>
									</div>
									<div
										style="position: absolute; top: 5px; right: 18px"
										v-if="dirtyMcqQuestion && !$v.mcqquestion.question.required"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
							<b-col cols="12">
								<template>
									<div
										v-if="
											mcqquestion.questionMedia != null &&
												this.checkMedia == true
										"
										class="mt-4 mediaPosition"
									>
										<div class="relativeclass">
											<div @click="cancelmcqmedia()" class="qb-cancel-image">
												<img src="../../assets/CloseImg.svg" alt="" />
											</div>
											<div
												class="dbmcqcardimage"
												v-if="isImage(mcqquestion.questionMediaType)"
											>
												<img
													class="w-100 h-100"
													:src="mcqquestion.questionMedia"
													alt=""
												/>
											</div>
											<div v-if="isAudio(mcqquestion.questionMediaType)">
												<Media
													:kind="'audio'"
													:isMuted="false"
													:src="mcqquestion.questionMedia"
													:autoplay="false"
													:controls="true"
													:loop="true"
													width="70%"
													class="qb-audio-preview"
												></Media>
											</div>
											<div v-if="isVideo(mcqquestion.questionMediaType)">
												<Media
													:kind="'video'"
													:isMuted="false"
													:src="mcqquestion.questionMedia"
													:autoplay="false"
													:controls="true"
													:loop="true"
													width="70%"
													height="30%"
													class="qb-vedio-preview"
												></Media>
											</div>
										</div>
									</div>
								</template>
							</b-col>
						</b-row>
						<b-row v-if="showVideoUploading">
							<b-col class="ab-uploaded-card w-100 mt-3">
								<b-card no-body class="d-flex w-100">
									<section class="d-flex align-items-center pt-1">
										<div
											class="ab-uploaded-file-heading d-flex align-items-center w-75"
										>
											{{ videoData.name }}
										</div>

										<div
											class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
										>
											<b-spinner
												v-if="showSpinner"
												label="Spinning"
											></b-spinner>
											<span>{{ formatSize(videoData.size) }}</span>
											<!-- <span class="ml-2"> 2 sec Left</span> -->
										</div>
										<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
									</section>
									<section class="mt-2">
										<b-progress :value="progress" height="4px" />
									</section>
								</b-card>
							</b-col>
						</b-row>
						<div class="select-option mt-3" v-if="singletick == true">
							Select an Option<span class="asterik">*</span>
						</div>
						<div class="error_msg mt-3" v-if="erroroption == true">
							<div class="error_text">
								To add a question, please select one of the options here.
							</div>
						</div>

						<div
							class="mt-2 ml-3 sec-quesbox-radios sec-addquesbox-rightside-questionbank"
						>
							<b-row class="p-2 align-items-end">
								<b-col
									cols="6"
									v-for="(i, index) in mcqquestion.options"
									:key="index"
									:class="{
										'mt-3': index > 0,
									}"
								>
									<div class="relativeclass d-flex align-items-center">
										<div
											class="mcq-checkbox"
											:class="{
												'mt-40px': optionPreviews[index],
											}"
										>
											<b-form-checkbox
												v-model.trim="i.check"
												@change="icheck"
												name="some-radios"
											></b-form-checkbox>
										</div>

										<div class="position-relative w-100">
											<b-form-input
												:placeholder="`Enter option ${index + 1}`"
												v-model="i.value"
												:class="optionPreviews[index] ? 'h-150px' : ''"
												:disabled="i.media !== ''"
											>
											</b-form-input>
											<div v-if="optionPreviews[index]">
												<div
													class="uploaded-option-image"
													@mouseover="showoptionImageicons = index"
													@mouseleave="showoptionImageicons = null"
												>
													<img
														:src="optionPreviews[index]"
														alt=""
														class="w-100 h-100 overflow-hidden"
														style="border-radius: 4px;"
													/>
													<div
														v-if="showoptionImageicons === index"
														class="image-blur-overlay"
													></div>
													<div
														class="align-items-center mcq-image-option-hovered-icons"
														v-if="showoptionImageicons === index"
													>
														<img
															src="../../assets/icons/Qpbuilder/imagepreview.svg"
															alt=""
															class="pointer"
															@click.stop.prevent="
																openPreview(optionPreviews[index])
															"
														/>
														<img
															src="../../assets/icons/Qpbuilder/imageclose.svg"
															alt=""
															class="pointer ml-2"
															@click.stop="removeOptionImage(i, index)"
														/>
													</div>
												</div>
											</div>
											<div
												:style="{
													position: 'absolute',
													top: '12px',
													right:
														mcqquestion.options.length > 2 && i.check !== true
															? '50px'
															: '30px',
												}"
												v-if="
													$v.mcqquestion.options.$each[index].value.$dirty &&
														!$v.mcqquestion.options.$each[index].value
															.valueOrMediaRequired
												"
												v-b-popover.hover.top.v-danger="{ content: 'Required' }"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
										</div>
										<div
											class="mcq-radio-option-delete"
											v-if="mcqquestion.options.length > 2 && i.check != true"
										>
											<img
												class="pointer"
												src="../../assets/graydelete.svg"
												alt=""
												@click="deleteOptions(index)"
											/>
										</div>
										<div>
											<label
												:for="`file-upload-imagemcq-${index}`"
												class="pointer"
											>
												<img
													:class="{
														right27px:
															mcqquestion.options.length > 2 && i.check != true,
													}"
													class="mcq-radio-option-image"
													src="../../assets/icons/Qpbuilder/optionimage.svg"
													alt=""
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Image supported formats are: jpg, jpeg, png"
												/>
											</label>
											<input
												:id="`file-upload-imagemcq-${index}`"
												type="file"
												accept="image/*"
												@change="previewOptionfile($event, index)"
												style="display: none"
											/>
										</div>
									</div>
								</b-col>
							</b-row>
						</div>
					</div>
					<div class="asterik" v-if="moreOption">
						Cannot add more than 8 options<span class="asterik">*</span>
					</div>

					<div class="mt-2 d-flex justify-content-between">
						<div class="pointer mcq-bottom-options">
							<div @click="addOptions()" class="pointer">
								<span><img src="../../assets/secplusicon.svg" alt=""/></span>
								<span class="ml-2 qb-add-more-matches">Add more options</span>
							</div>
						</div>

						<div>
							<b-button
								class="addbtn"
								@click="
									mcqQuestionStatus === 'Add'
										? addMcqQuestion()
										: saveMcqbEdit()
								"
							>
								<span class="pl-2 pr-2 pt-1 pb-1">{{
									mcqQuestionStatus === "Add" ? "Add" : "Update"
								}}</span>
							</b-button>
							<b-button
								class="cancel-btn"
								variant="outline"
								@click="killaddmcqmodal()"
								>Cancel</b-button
							>
						</div>
					</div>
				</div>
			</b-modal>

			<!-- Add MCQ question Ends -->

			<!-- Add MAFO question Modal Starts -->
			<b-modal
				id="modal-match-add"
				centered
				hide-footer
				hide-header
				class="qb-add-ques-modal"
				size="lg"
				no-close-on-backdrop
				@hidden="resetMatchAddModal"
			>
				<div class="">
					<div @click="killaddmatchmodal()" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<div class="tp-cardhead">{{ matchQuestionStatus }} MTF</div>
					<div :class="{ 'form-disabled': isUploadLocked }">
						<div class="qb-match-options-overflow" ref="mtfModalContent">
							<b-row>
								<b-col>
									<div class="topDiv mt-3">
										<label class="disabledfieldsetStyle"
											>Question Type<span class="asterik">*</span></label
										>
										<b-form-input
											type="text"
											v-model="matchquestion.questionType"
											class="disabledinputField"
											disabled
										></b-form-input>
									</div>
								</b-col>
								<b-col>
									<div class="qb-blue-parent topDiv mt-3">
										<label class="fieldsetStyle sharelabel"
											>Marks<span class="asterik">*</span></label
										>
										<b-form-input
											type="number"
											class="qb-other-text"
											v-model="$v.matchquestion.marks.$model"
											:class="{
												error: $v.matchquestion.marks.$error || checkDec,
											}"
											min="0"
											max="100"
											@keypress="validateInput($event)"
											@input="checkDecimalMTF"
											placeholder="Marks"
										></b-form-input>
										<div
											class="marks-delete-icon"
											v-if="
												$v.matchquestion.marks.$dirty &&
													!$v.matchquestion.marks.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											class="marks-delete-icon"
											v-if="
												!$v.matchquestion.marks.between &&
													$v.matchquestion.marks.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between (0.5, 100)',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											class="marks-delete-icon"
											v-if="checkDec"
											v-b-popover.hover.top.v-danger="{
												content: 'Accepts only 2 digit after decimal point',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row class="questiontagcontainer">
								<b-col cols="6">
									<div class="topDiv mt-4 qb-other-textDIff">
										<label class="fieldsetStyle"
											>Difficulty Level &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<div
											class="editquesdropdown d-flex justify-content-between pointer"
											@click="qbdropdiff = !qbdropdiff"
											:class="{
												error: $v.matchquestion.difficultyLevel.$error,
											}"
										>
											<span
												>Difficulty Level
												{{ matchquestion.difficultyLevel }}</span
											>
											<span>
												<img
													v-if="qbdropdiff"
													src="../../assets/uparrow.svg"
													alt=""
													class="mr-1"
												/>
												<img
													v-else
													src="../../assets/downarrow.svg"
													alt=""
													class="mr-1"
												/>
											</span>
										</div>
										<div
											style="position: absolute; top: 20%; right: 10%"
											v-if="
												$v.matchquestion.difficultyLevel.$dirty &&
													!$v.matchquestion.difficultyLevel.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											v-if="qbdropdiff"
											class="qb-dropdown-option-add-1 d-flex"
										>
											<b-form-group
												class="qb-dd-group-diff"
												v-slot="{ ariaDescribedby }"
											>
												<b-form-radio-group
													@change="qbdropdiff = !qbdropdiff"
													class="qb-add-drop width-full"
													id="btn-radios-4"
													v-model="$v.matchquestion.difficultyLevel.$model"
													:options="options"
													:aria-describedby="ariaDescribedby"
													name="radio-btn-stacked"
													buttons
													stacked
												></b-form-radio-group>
											</b-form-group>
										</div>
									</div>
								</b-col>
								<b-col cols="6">
									<div class="qb-blue-parent topDiv mt-4 ckeditor">
										<label class="addquesboxfieldsetStyle">
											Question Tags</label
										>
										<b-form-tags
											remove-on-delete
											v-model="matchquestion.questionTags"
											no-outer-focus
											separator=" "
											add-on-change
										>
											<template
												v-slot="{
													tags,
													inputAttrs,
													inputHandlers,
													tagVariant,
													removeTag,
													addTag,
												}"
											>
												<b-input-group
													class="mb-2 d-flex"
													id="mtfaddcontainer-tag"
												>
													<div
														style="width: 85%"
														class="qb-transparent d-flex cust-group-input"
													>
														<div
															class="d-inline-block cust-btn-select mt-2"
															style="font-size: 1.5rem"
														>
															<b-form-tag
																v-for="tag in tags"
																@remove="removeTag(tag)"
																:key="tag"
																:title="tag"
																:variant="tagVariant"
																class="ml-1"
																>{{ tag }}</b-form-tag
															>
														</div>
														<b-form-input
															id="match-add-tag"
															v-bind="inputAttrs"
															v-on="inputHandlers"
															@keyup="hashtagmatchadd()"
															@keyup.enter="addTagAndResetInputMTF()"
															@keyup.space="addTagAndResetInputMTF()"
															@keydown.tab.prevent="addTagAndResetInputMTF()"
															placeholder="Enter Question tag"
															style="border-bottom: unset"
															class="form-control min-width mr-4 ml-2"
															v-model="tagmodal"
														></b-form-input>
													</div>
													<b-input-group-append>
														<b-button
															:disabled="tagmodal == ''"
															@click="addTag(), (tagmodal = '')"
															variant="outline"
															class="cursor-pointer"
														>
															<img
																src="../../assets/addicongraywhite.svg"
																alt=""
															/>
														</b-button>
													</b-input-group-append>
												</b-input-group>
											</template>
										</b-form-tags>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="12">
									<div class="topDiv mt-3 relativeclass">
										<div
											:class="
												dirtyMtfQuestion ||
												(!$v.matchquestion.question.maxLength &&
													!dirtyMtfQuestion)
													? 'error'
													: ''
											"
										>
											<label class="addquesboxfieldsetStyle" style="z-index: 5">
												Question &nbsp;<span class="asterik">*</span></label
											>

											<QuillEditor
												:addquesProp="addquesMatch"
												:value="$v.matchquestion.question.$model"
												@validationVal="validateText"
												@questionText="updateQuestionContent"
												@addquesBack="changedaddQues"
											>
											</QuillEditor>

											<div
												style="position: absolute; top: 5px; right: 3vw"
												v-if="
													dirtyMtfQuestion && $v.matchquestion.question.required
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Required',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>

											<div
												style="position: absolute; top: 5px; right: 3vw"
												v-if="
													!$v.matchquestion.question.maxLength &&
														!dirtyMtfQuestion
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Should not exceed 10000 characters',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
										</div>
										<div class="media-box mt-2 align-items-center">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div class="d-flex align-items-center">
													<div class="media-text ml-3">Add Media</div>
													<div class="ml-2">
														<img src="../../assets/vertical-line.svg" alt="" />
													</div>
													<div class="d-flex align-items-center ml-2 mt-1">
														<div
															class="ml-2"
															v-b-tooltip.hover="{ variant: 'secondary' }"
															title="Audio supported formats are: wav, mp3"
														>
															<label for="file-upload" class="pointer">
																<img src="../../assets/headphone.svg" alt="" />
															</label>
															<input
																id="file-upload"
																type="file"
																accept="audio/*"
																@change="previewFileMatch"
															/>
														</div>
														<div
															class="ml-3"
															v-b-tooltip.hover="{ variant: 'secondary' }"
															title="Video supported formats is: mp4"
														>
															<label for="file-upload-video" class="pointer">
																<img src="../../assets/videocam.svg" alt="" />
															</label>
															<input
																id="file-upload-video"
																type="file"
																accept="video/*"
																@change="previewFileMatch"
															/>
														</div>
														<div
															class="ml-3"
															v-b-tooltip.hover="{ variant: 'secondary' }"
															title="Image supported formats are: jpg, jpeg, png"
														>
															<label for="file-upload-image" class="pointer">
																<img
																	src="../../assets/image-capture.svg"
																	alt=""
																/>
															</label>
															<input
																id="file-upload-image"
																type="file"
																accept="image/*"
																@change="previewFileMatch"
															/>
														</div>
													</div>
												</div>
												<div
													class="d-flex align-items-center"
													v-if="matchquestion.isFailed == true"
												>
													<img
														src="../../assets/Vector.svg"
														alt=""
														class="mr-2"
													/>
													<p class="uploadfailed mb-0 mr-2">
														Invalid media file
													</p>
												</div>
											</div>
										</div>
										<div
											style="position: absolute; top: 5px; right: 3vw"
											v-if="
												dirtyMtfQuestion && !$v.matchquestion.question.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="12">
									<template>
										<div
											v-if="
												matchquestion.questionMedia != null &&
													this.checkMedia == true
											"
											class="mt-4 mediaPosition"
										>
											<div class="relativeclass">
												<div
													@click="cancelmatchmedia()"
													class="qb-cancel-image"
												>
													<img src="../../assets/CloseImg.svg" alt="" />
												</div>
												<div
													v-if="isImage(matchquestion.questionMediaType)"
													class="dbmcqcardimage"
												>
													<img
														class="w-100 h-100"
														:src="matchquestion.questionMedia"
														alt=""
													/>
												</div>
												<div v-if="isAudio(matchquestion.questionMediaType)">
													<Media
														:kind="'audio'"
														:isMuted="false"
														:src="matchquestion.questionMedia"
														:autoplay="false"
														:controls="true"
														:loop="true"
														width="70%"
														class="qb-audio-preview"
													>
													</Media>
												</div>
												<div v-if="isVideo(matchquestion.questionMediaType)">
													<Media
														:kind="'video'"
														:isMuted="false"
														:src="matchquestion.questionMedia"
														:autoplay="false"
														:controls="true"
														:loop="true"
														width="70%"
														height="30%"
														class="qb-vedio-preview"
													></Media>
												</div>
											</div>
										</div>
									</template>
								</b-col>
							</b-row>
							<b-row v-if="showVideoUploading">
								<b-col class="ab-uploaded-card w-100 mt-3">
									<b-card no-body class="d-flex w-100">
										<section class="d-flex align-items-center pt-1">
											<div
												class="ab-uploaded-file-heading d-flex align-items-center w-75"
											>
												{{ videoData.name }}
											</div>

											<div
												class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
											>
												<b-spinner
													v-if="showSpinner"
													label="Spinning"
												></b-spinner>
												<span>{{ formatSize(videoData.size) }}</span>
												<!-- <span class="ml-2"> 2 sec Left</span> -->
											</div>
											<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
										</section>
										<section class="mt-2">
											<b-progress height="4px" :value="progress"></b-progress>
										</section>
									</b-card>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="">
									<div
										class="d-flex qb-ques-text"
										v-for="(option, index) of matchquestion.answerKey"
										:key="index"
									>
										<div class="editTopDiv mt-3">
											<label class="fieldsetStyle sharelabel"
												>Match{{ index + 1 }}</label
											>
											<b-form-input
												type="text"
												v-model="option.sideA"
											></b-form-input>
											<div
												style="position: absolute; top: 5px; right: 3vw"
												v-if="
													$v.matchquestion.answerKey.$each[index].sideA.$error
												"
												v-b-popover.hover.top.v-danger="{ content: 'Required' }"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
										</div>
										<div class="leftright-match mt-3 pt-1">
											<img src="../../assets/leftright.svg" alt="" />
										</div>

										<div class="editTopDiv mt-3">
											<label class="fieldsetStyle sharelabel"
												>Match{{ index + 1 }}</label
											>
											<b-form-input
												type="text"
												v-model="option.sideB"
											></b-form-input>
											<div
												style="position: absolute; top: 5px; right: 3vw"
												v-if="
													$v.matchquestion.answerKey.$each[index].sideB.$error
												"
												v-b-popover.hover.top.v-danger="{ content: 'Required' }"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<img
												v-if="matchquestion.answerKey.length > 3"
												src="../../assets/graydelete.svg"
												alt=""
												class="qb-match-delete"
												@click="deletematchoptions(index)"
											/>
										</div>
									</div>
								</b-col>
							</b-row>
						</div>

						<div class="asterik" v-if="moreOption">
							Cannot add more than 8 options<span class="asterik">*</span>
						</div>

						<div class="mt-3 d-flex justify-content-between">
							<div class="pointer" @click="addMatchOptions()">
								<span
									><img src="../../assets/addicongraywhite.svg" alt=""
								/></span>
								<span class="ml-2 qb-add-more-matches">Add more matches</span>
							</div>
							<div>
								<b-button class="addbtn">
									<span
										class="pl-2 pr-2 pt-1 pb-1"
										@click="
											matchQuestionStatus === 'Add'
												? addMatchQuestion()
												: saveMachEdit()
										"
									>
										<span class="pl-2 pr-2 pt-1 pb-1">{{
											matchQuestionStatus === "Add" ? "Add" : "Update"
										}}</span></span
									>
								</b-button>
								<b-button
									class="cancel-btn"
									variant="outline"
									@click="killaddmatchmodal"
									>Cancel</b-button
								>
							</div>
						</div>
					</div>
				</div>
			</b-modal>

			<!-- Add MAFO question Modal Ends -->
			<!-- Descriptive mofdal start -->
			<b-modal
				id="modal-descriptive-add"
				centered
				hide-footer
				hide-header
				class="qb-add-ques-modal"
				size="lg"
				no-close-on-backdrop
				@hidden="resetDescriptiveAddModal"
			>
				<div class="modalheading">{{ mcqQuestionStatus }} Descriptive</div>
				<div @click="killadddescriptivemodal()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<div :class="{ 'form-disabled': isUploadLocked }">
					<div class="qb-match-options-overflow">
						<b-row>
							<b-col>
								<div class="topDiv mt-3 relativeclass">
									<label class="disabledfieldsetStyle"
										>Question Type &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										type="text"
										v-model="longquestion.questionType"
										class="disabledinputField"
										disabled
									></b-form-input>
								</div>
							</b-col>
							<b-col>
								<div class="qb-blue-parent topDiv mt-3 relativeclass">
									<label class="fieldsetStyle"
										>Marks &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="qb-ques-text"
										type="number"
										v-model="$v.longquestion.marks.$model"
										:class="{
											error: $v.longquestion.marks.$error || checkDec,
										}"
										min="0"
										max="100"
										@keypress="validateInput($event)"
										@input="checkDecimalLONG"
										placeholder="Marks"
									></b-form-input>
									<div
										class="marks-delete-icon"
										v-if="
											$v.longquestion.marks.$dirty &&
												!$v.longquestion.marks.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="marks-delete-icon"
										v-if="
											!$v.longquestion.marks.between &&
												$v.longquestion.marks.required
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Should be between (0.5, 100)',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="marks-delete-icon"
										v-if="checkDec"
										v-b-popover.hover.top.v-danger="{
											content: 'Accepts only 2 digit after decimal point',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row class="questiontagcontainer">
							<b-col cols="6">
								<div class="topDiv mt-4 qb-other-textDIff">
									<label class="fieldsetStyle"
										>Difficulty Level &nbsp;<span class="asterik"
											>*</span
										></label
									>
									<div
										class="editquesdropdown d-flex justify-content-between pointer"
										@click="qbdropdiff = !qbdropdiff"
										:class="{
											error: $v.longquestion.difficultyLevel.$error,
										}"
									>
										<span
											>Difficulty Level {{ longquestion.difficultyLevel }}</span
										>
										<span>
											<img
												v-if="qbdropdiff"
												src="../../assets/uparrow.svg"
												alt=""
												class="mr-1"
											/>
											<img
												v-else
												src="../../assets/downarrow.svg"
												alt=""
												class="mr-1"
											/>
										</span>
									</div>
									<div
										style="position: absolute; top: 20%; right: 10%"
										v-if="
											$v.longquestion.difficultyLevel.$dirty &&
												!$v.longquestion.difficultyLevel.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										v-if="qbdropdiff"
										class="qb-dropdown-option-add-1 d-flex"
									>
										<b-form-group
											class="qb-dd-group-diff"
											v-slot="{ ariaDescribedby }"
										>
											<b-form-radio-group
												@change="qbdropdiff = !qbdropdiff"
												class="qb-add-drop width-full"
												id="btn-radios-4"
												v-model="$v.longquestion.difficultyLevel.$model"
												:options="options"
												:aria-describedby="ariaDescribedby"
												name="radio-btn-stacked"
												buttons
												stacked
											></b-form-radio-group>
										</b-form-group>
									</div>
								</div>
							</b-col>
							<b-col cols="6">
								<div class="qb-blue-parent topDiv mt-4 ckeditor">
									<label class="addquesboxfieldsetStyle"> Question Tags</label>
									<b-form-tags
										remove-on-delete
										v-model="longquestion.questionTags"
										no-outer-focus
										separator=" "
									>
										<template
											v-slot="{
												tags,
												inputAttrs,
												inputHandlers,
												tagVariant,
												removeTag,
												addTag,
											}"
										>
											<b-input-group class="mb-2" id="mcqaddcontainer-tag">
												<div
													style="width: 85%"
													class="qb-transparent d-flex cust-group-input"
												>
													<div
														class="d-inline-block cust-btn-select mt-2"
														style="font-size: 1.5rem"
													>
														<b-form-tag
															v-for="tag in tags"
															@remove="removeTag(tag)"
															:key="tag"
															:title="tag"
															:variant="tagVariant"
															class="ml-1"
															>{{ tag }}</b-form-tag
														>
													</div>
													<b-form-input
														id="descriptive-add-tag"
														v-bind="inputAttrs"
														v-on="inputHandlers"
														@keyup="hashtaglongadd()"
														@keyup.enter="addTagAndResetInputLONG()"
														@keyup.space="addTagAndResetInputLONG()"
														@keydown.tab.prevent="addTagAndResetInputLONG()"
														placeholder="Enter Question tag"
														style="border-bottom: unset"
														class="form-control min-width mr-4 ml-2"
														v-model="tagmodal"
													></b-form-input>
												</div>
												<b-input-group-append>
													<b-button
														:disabled="tagmodal == ''"
														@click="addTag(), (tagmodal = '')"
														variant="outline"
														class="cursor-pointer"
													>
														<img
															src="../../assets/addicongraywhite.svg"
															alt=""
														/>
													</b-button>
												</b-input-group-append>
											</b-input-group>
										</template>
									</b-form-tags>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="12">
								<div class="topDiv mt-3 relativeclass">
									<div
										:class="
											dirtyLongQuestion ||
											(!$v.longquestion.question.maxLength &&
												!dirtyLongQuestion)
												? 'error'
												: ''
										"
									>
										<label class="addquesboxfieldsetStyle" style="z-index: 5">
											Question &nbsp;<span class="asterik">*</span></label
										>

										<QuillEditor
											:addquesProp="addquesLong"
											:value="$v.longquestion.question.$model"
											@validationVal="validateText"
											@questionText="updateQuestionContent"
											@addquesBack="changedaddQues"
										>
										</QuillEditor>

										<div
											style="position: absolute; top: 5px; right: 18px"
											v-if="
												dirtyLongQuestion && $v.longquestion.question.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Required',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>

										<div
											style="position: absolute; top: 5px; right: 18px"
											v-if="
												!$v.longquestion.question.maxLength &&
													!dirtyLongQuestion
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 10000 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>

									<div class="media-box mt-2 align-items-center">
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="d-flex align-items-center">
												<div class="media-text ml-3">Add Media</div>
												<div class="ml-2">
													<img src="../../assets/vertical-line.svg" alt="" />
												</div>
												<div class="d-flex align-items-center ml-2 mt-1">
													<div
														class="ml-2"
														v-b-tooltip.hover="{ variant: 'secondary' }"
														title=" Audio supported formats are: wav, mp3"
													>
														<label for="file-upload" class="pointer">
															<img src="../../assets/headphone.svg" alt="" />
														</label>
														<input
															id="file-upload"
															type="file"
															accept="audio/*"
															@change="previewFileDesc"
														/>
													</div>
													<div
														class="ml-3"
														v-b-tooltip.hover="{ variant: 'secondary' }"
														title="Video supported formats is: mp4"
													>
														<label for="file-upload-video" class="pointer">
															<img src="../../assets/videocam.svg" alt="" />
														</label>
														<input
															id="file-upload-video"
															type="file"
															accept="video/*"
															@change="previewFileDesc"
														/>
													</div>
													<div
														class="ml-3"
														v-b-tooltip.hover="{ variant: 'secondary' }"
														title="Image supported formats are: jpg, jpeg, png"
													>
														<label for="file-upload-image" class="pointer">
															<img
																src="../../assets/image-capture.svg"
																alt=""
															/>
														</label>
														<input
															id="file-upload-image"
															type="file"
															accept="image/*"
															@change="previewFileDesc"
														/>
													</div>
												</div>
											</div>
											<div
												class="d-flex align-items-center"
												v-if="longquestion.isFailed == true"
											>
												<img
													src="../../assets/Vector.svg"
													alt=""
													class="mr-2"
												/>
												<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
											</div>
										</div>
									</div>
									<div
										style="position: absolute; top: 5px; right: 18px"
										v-if="
											dirtyLongQuestion && !$v.longquestion.question.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
							<b-col cols="12">
								<template>
									<div
										v-if="
											longquestion.questionMedia != null &&
												this.checkMedia == true
										"
										class="mt-4 mediaPosition"
									>
										<div class="relativeclass">
											<div @click="cancellongmedia()" class="qb-cancel-image">
												<img src="../../assets/CloseImg.svg" alt="" />
											</div>
											<div
												class="dbmcqcardimage"
												v-if="isImage(longquestion.questionMediaType)"
											>
												<img
													class="w-100 h-100"
													:src="longquestion.questionMedia"
													alt=""
												/>
											</div>
											<div v-if="isAudio(longquestion.questionMediaType)">
												<Media
													:kind="'audio'"
													:isMuted="false"
													:src="longquestion.questionMedia"
													:autoplay="false"
													:controls="true"
													:loop="true"
													width="70%"
													class="qb-audio-preview"
												></Media>
											</div>
											<div v-if="isVideo(longquestion.questionMediaType)">
												<Media
													:kind="'video'"
													:isMuted="false"
													:src="longquestion.questionMedia"
													:autoplay="false"
													:controls="true"
													:loop="true"
													width="70%"
													height="30%"
													class="qb-vedio-preview"
												></Media>
											</div>
										</div>
									</div>
								</template>
							</b-col>
						</b-row>
						<b-row v-if="showVideoUploading">
							<b-col class="ab-uploaded-card w-100 mt-3">
								<b-card no-body class="d-flex w-100">
									<section class="d-flex align-items-center pt-1">
										<div
											class="ab-uploaded-file-heading d-flex align-items-center w-75"
										>
											{{ videoData.name }}
										</div>

										<div
											class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
										>
											<b-spinner
												v-if="showSpinner"
												label="Spinning"
											></b-spinner>
											<span>{{ formatSize(videoData.size) }}</span>
											<!-- <span class="ml-2"> 2 sec Left</span> -->
										</div>
										<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
									</section>
									<section class="mt-2">
										<b-progress height="4px" :value="progress"></b-progress>
									</section>
								</b-card>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="topDiv mt-3 relativeclass">
									<label class="addquesboxfieldsetStyle"> Answer &nbsp;</label>
									<b-form-textarea
										placeholder="Enter something..."
										rows="3"
										max-rows="6"
										v-model="$v.longquestion.correctAnswer.$model"
										:class="{
											error: $v.longquestion.correctAnswer.$error,
										}"
									></b-form-textarea>
									<div
										style="position: absolute; top: 5px; right: 8px"
										v-if="!$v.longquestion.correctAnswer.maxLength"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not exceed 1024 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</b-col>
						</b-row>
					</div>

					<div class="mt-5 d-flex justify-content-end">
						<div>
							<b-button
								class="pl-2 pr-2 pt-1 pb-1"
								@click="
									descriptiveQuestionStatus === 'Add'
										? addDescriptiveQuestion()
										: saveDescriptivebEdit()
								"
							>
								<span class="pl-2 pr-2 pt-1 pb-1">{{
									descriptiveQuestionStatus === "Add" ? "Add" : "Update"
								}}</span>
							</b-button>
							<b-button
								class="cancel-btn"
								variant="outline"
								@click="killadddescriptivemodal()"
								>Cancel</b-button
							>
						</div>
					</div>
				</div>
			</b-modal>
			<b-modal
				id="confirm-edit-modal"
				centered
				hide-footer
				hide-header
				no-close-on-backdrop
				class="qb-add-ques-modal"
			>
				<div
					class="modalheading d-flex align-items-center justify-content-between"
				>
					Caution !
					<img class="pr-3" src="../../assets/caution.svg" alt="" />
				</div>
				<div @click="$bvModal.hide('confirm-edit-modal')" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<hr />
				<div class="mt-3 caution-modal-text">
					<span>Are you sure you want to update ?</span>
				</div>
				<div class="mt-2 caution-modal-text">
					This question is tagged to more than one test. Do you want to create a
					new question or confirm the action?
				</div>
				<div class="mt-2 normaltext">
					<span class="asterik">*</span
					><span>Please note this action cannot be undone</span>
				</div>
				<div class="d-flex align-items-center justify-content-end mt-3">
					<b-button
						class="addbtn mr-2"
						@click="
							selquestype == 'MCQ'
								? addMcqQuestion()
								: selquestype == 'MTF'
								? addMatchQuestion()
								: selquestype == 'LONG'
								? addDescriptiveQuestion()
								: ''
						"
						>Create New</b-button
					>
					<!-- {{ check}} -->
					<div class="sec-canceltext pointer" @click="confirm()">Confirm</div>
				</div>
			</b-modal>
			<b-modal
				id="viewimagemodal"
				centered
				hide-footer
				hide-header
				v-model="isImageModalOpen"
			>
				<div class="">
					<img
						:src="previewImage"
						alt="Preview"
						class="h-100 w-100 overflow-hidden border-image"
						v-if="previewImage"
					/>
				</div>
			</b-modal>
			<div
				v-if="isImageModalOpen"
				@click="isImageModalOpen = false"
				class="mcq-image-modalclose pointer"
			>
				<img
					class="rotate-on-hover"
					src="../../assets/icons/Qpbuilder/imageclose2.svg"
					alt=""
				/>
			</div>
		</div>
		<template v-if="showCommunicationModal">
			<CommunicationQuestionModal
				:key="$route.name"
				:showModal="showCommunicationModal"
				:status="communicationType"
				:selectedData="selectedCommunicationQues"
				@close-modal="closeCommunicationModal"
				@get-questions="getquestionbank"
			/>
		</template>
	</div>
</template>

<script>
let XLSX = require("xlsx");
import QuillEditor from "../../components/forms/quillEditor.vue"; //Quill editor from component
import {
	getDataBank,
	postMCQquestionv2,
	postMatchTheFollowingQuestionv2,
	putMCQquestionv2,
	putMatchTheFollowingQuestionv2,
	postCommonQuestionv2,
	deleteMultipleQuestion,
	forcedeletemultiplequestions,
	getAllQuestionTags,
	getExcelTemplate,
	postExcel,
	putCommonQuestionv2,
} from "../../utils/apiFunctions.js";
import CommunicationQuestionModal from "@/components/modals/communicationQuestionModal.vue";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";

import {
	required,
	between,
	maxLength,
	helpers,
} from "vuelidate/lib/validators";
import Media from "@dongido/vue-viaudio";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";
import socketUploadMixin from "@/views/mixin/socketUploadMixin";
import { mapGetters, mapState } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
const valueOrMediaRequired = helpers.withParams(
	{ type: "valueOrMediaRequired" },
	function(value, parentVm) {
		return !!value || !!parentVm.media;
	}
);
export default {
	name: "MCQCard",
	mixins: [successToast, errorToast, socketUploadMixin],
	data() {
		return {
			showVideoUploading: false, // controls upload UI + form lock
			videoData: {}, // holds uploaded file
			progress: 0, // optional (if you already have)
			// uploadState: {
			// 	mcq: {
			// 		uploading: false,
			// 		showUI: false,
			// 		file: null,
			// 		progress: 0,
			// 	},
			// 	match: {
			// 		uploading: false,
			// 		showUI: false,
			// 		file: null,
			// 		progress: 0,
			// 	},
			// 	long: {
			// 		uploading: false,
			// 		showUI: false,
			// 		file: null,
			// 		progress: 0,
			// 	},
			// },
			showSpinner: false,
			previewImage: "",
			isImageModalOpen: false,
			addquesMatch: false,
			addquesMcq: false,
			addquesLong: false,
			showCommunicationModal: false,

			tagmodal: "",
			checkDec: false,
			dirtyMcqQuestion: false,
			dirtyMtfQuestion: false,

			dirtyLongQuestion: false,

			searchexcelsheets: "",
			communicationType: "Add",

			selectedFailQuestions: [],
			selectedMediaType: [],
			failedTopic: {},
			failedTests: {},
			selectedCommunicationQues: {},
			deleteQuestionmodel: "",
			checked: true,
			singlesheets: "",
			LoaderStatus: false,
			showselecteddropdown: false,
			moreOption: false,
			singletick: true,
			erroroption: false,
			excelSheetName: [],
			excelSheetNameShow: [],
			allQuestions: [],
			index: 10,
			notviewable: false,
			excelFile: "",
			SheetName: "",
			selected: "",
			selquestype: "",
			downloadLink: "",
			toasttext: "",
			page: 0,
			check: true,
			sorting: false,
			qbdrop: false,
			qbdropadd: false,
			qbdropdiff: false,
			status: false,
			difficulty_type: ["medium"],
			goToPage: null,
			adddisable: false,
			addquestion: "",
			totalPages: null,
			difficultyedit: "",
			selectall: false,
			force: [],
			deleted: [],
			selectedquestion: [],
			difficulty: "",
			file: "",
			selectedQuestions: [],
			mcqQuestionStatus: "",
			matchQuestionStatus: "",
			descriptiveQuestionStatus: "",
			sortColumn: "createdAt",
			checkMedia: false,
			pageStart: "",
			pageEnd: "",
			filter: {
				questiontype_selected: [],
				marks: "",
				difficulty_type: [],
				questionTags: [],
			},
			storefilterdata: {
				questiontype_selected: [],
				marks: "",
				difficulty_type: [],
				questionTags: [],
			},
			storeselectedMediaType: [],
			skilloptions: [
				{ name: "Java", code: "java" },
				{ name: "SQL", code: "sql" },
				{ name: "c++", code: "c++" },
				{ name: "c", code: "c" },
			],
			mediatypeOptions: [
				{ text: "Image", value: "Image" },
				{ text: "Audio", value: "Audio" },
				{ text: "Video", value: "Video" },
			],
			allQuestionTags: [],
			editorConfig: {
				toolbar: ["Bold", "Italic", "-", "NumberedList", "BulletedList", "-"],
				autoParagraph: false,
			},
			mcqquestion: {
				questionType: "MCQ",
				addToDatabank: true,
				question: "",
				options: [
					{
						value: "",
						media: "",
						check: false,
					},
					{
						value: "",
						media: "",
						check: false,
					},
				],
				difficultyLevel: "",
				questionTags: "",
				required: false,
				autoCorrection: false,
				marks: "",
				addToPublic: false,
				topic: "",
				questionMedia: "",
				questionMediaType: "",
				isFailed: false,

				// delete: 1,
			},
			longquestion: {
				questionType: "Descriptive",
				addToDatabank: true,
				question: "",
				difficultyLevel: "",
				questionTags: "",
				required: false,
				autoCorrection: false,
				marks: "",
				addToPublic: false,
				topic: "",
				questionMedia: "",
				questionMediaType: "",
				isFailed: false,
				correctAnswer: "",
				// delete: 1,
			},
			questagmore: true,
			matchquestion: {
				questionType: "MTF",
				answerKey: [],
				difficultyLevel: "",
				addToDatabank: true,
				required: false,
				autoCorrection: false,
				questionTags: [],
				marks: "",
				addToPublic: false,
				topic: "abc",
				questionMedia: "",
				questionMediaType: "",
				isFailed: false,
				// delete: 1
			},
			currentPage: 1,
			question_count: 50,
			showdiffoptions: false,
			diffoptions: [
				{
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					value: "5",
					text: "Difficulty Level 5",
				},
			],
			total: null,
			filtercount: 0,
			isclickprev: false,
			isclick: false,
			filtermodalshow: false,
			downloadType: "",
			vNodesTitle: [],
			totalques: 0,
			questionType: ["MCQU", "MAFO", "LONG"],
			questiontype_options: [
				{
					value: "MCQU",
					text: "Multiple Choice Question (MCQ)",
				},
				{
					value: "MAFO",
					text: "Match the Following (MTF)",
				},
				{
					value: "LONG",
					text: "Descriptive (DESC)",
				},
				//
				//     value: "SHORT",
				//     text: "Short Questions"
				// },
				// {
				//     value: "FIBL",
				//     text: "Unseen passage"
				// },

				// {
				//     value: "FIBL",
				//     text: "Fill in the blanks"
				// }
			],
			downloaQuesType: [
				{
					value: "MCQU",
					text: "Multiple Choice Question",
				},
				// {
				//   value: "MAFO",
				//   text: "Match the Following",
				// },
				{
					value: "LONG",
					text: "Descriptive",
				},
			],
			addquestiontype_options: [
				{
					value: "MCQ",
					text: "Multiple Choice Question(MCQ)",
				},
				{
					value: "MTF",
					text: "Match the Following(MTF)",
				},
				{
					value: "Descriptive",
					text: "Descriptive(DESC)",
				},
				// {
				//     value: "LONG",
				//     text: "Long Questions"
				// },
				//
				//     value: "SHORT",
				//     text: "Short Questions"
				// },
				// {
				//     value: "FIBL",
				//     text: "Unseen passage"
				// },

				// {
				//     value: "FIBL",
				//     text: "Fill in the blanks"
				// }
			],

			options: [
				{
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					value: "5",
					text: "Difficulty Level 5",
				},
			],
			questionTagOpen: false,
			searchquestiontag: "",
			optionPreviews: [],
			showoptionImageicons: null,
		};
	},
	watch: {
		searchTopicTestState() {
			this.LoaderStatus = true;
			if (this.searchTopicTestState.length > 0) {
				this.currentPage = 1;
			}

			// is triggered whenever the store state changes
			this.getquestionbank();
		},
		$route() {
			this.LoaderStatus = true;
			this.clearfilter();
			this.currentPage = 1;
			this.getquestionbank();
		},
	},
	components: {
		Spinner,
		Media,
		QuillEditor,
		CommunicationQuestionModal,
	},
	created() {
		this.LoaderStatus = true;
		this.getquestionbank();
		this.getExcelTemplate();
	},
	mounted() {
		const el = document.getElementById("top1");
		el.addEventListener("click", this.simple, false);
	},

	computed: {
		isUploadLocked() {
			return this.showVideoUploading;
		},
		excelSheetNamesearch() {
			return this.excelSheetName.filter((data) => {
				return (
					!this.searchexcelsheets ||
					data.toLowerCase().includes(this.searchexcelsheets.toLowerCase())
				);
			});
		},

		clearFilterclass() {
			return (
				this.filter.questiontype_selected == "" &&
				this.filter.questionTags == "" &&
				this.searchquestiontag == "" &&
				this.filter.marks == "" &&
				this.filter.difficulty_type == "" &&
				this.selectedMediaType == []
			);
		},
		// To check if it does not contain an alphabet or zero
		isValidPage() {
			return /^\d*$/.test(this.goToPage) && this.goToPage != 0;
		},

		filterallQuestionTags() {
			return this.allQuestionTags.filter((data) => {
				return (
					!this.searchquestiontag ||
					data.toLowerCase().includes(this.searchquestiontag.toLowerCase())
				);
			});
		},
		cssForDynamicColor() {
			return {
				"--dynamicBorderColor":
					"#" + ((Math.random() * 0xffffff) << 0).toString(16),
			};
		},

		...mapState("searchVUEX", {
			searchTopicTestState: "searchTopicTest",
		}),
		...mapGetters(["roles"]),
		isCommunicationTestQB() {
			return this.$route.name == "communicationTestQB" ? true : false;
		},
	},
	filters: {
		fnName: function(value) {
			if (value.length <= 22) {
				return value.slice(0, 22) + " ";
			} else {
				return value.slice(0, 22) + "...";
			}
		},
	},
	validations: {
		mcqquestion: {
			marks: {
				required,
				between: between(0.5, 100),
				// alpha: helpers.regex("alpha", /^[0-9]{1,3}\.{0,1}[0-9]{0,2}$/),
			},
			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
			options: {
				$each: {
					value: {
						valueOrMediaRequired,
						maxLength: maxLength(1024),
					},
				},
			},
		},
		longquestion: {
			marks: {
				required,
				between: between(0.5, 100),
				// alpha: helpers.regex("alpha", /^[0-9]{1,3}\.{0,1}[0-9]{0,2}$/),
			},
			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
			correctAnswer: {
				maxLength: maxLength(1024),
			},
		},

		matchquestion: {
			marks: {
				required,
				between: between(0.5, 100),
				// alpha: helpers.regex("alpha", /^[0-9]{1,3}\.{0,1}[0-9]{0,2}$/),
			},

			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},

			answerKey: {
				$each: {
					sideA: {
						required,
					},
					sideB: {
						required,
					},
				},
			},
		},
	},

	methods: {
		formatSize(bytes) {
			if (!bytes && bytes !== 0) return "";

			const kb = bytes / 1024;

			if (kb < 1024) {
				return `${kb.toFixed(1)} KB`;
			}

			return `${(kb / 1024).toFixed(1)} MB`;
		},
		openAddCommunicationModal() {
			this.communicationType = "Add";
			this.showCommunicationModal = true;
		},
		openEditCommunQues(i) {
			this.selectedCommunicationQues = i;
			console.log(this.selectedCommunicationQues);
			this.communicationType = "Edit";
			this.showCommunicationModal = true;
			console.log("log addeddddddddddddddddddddddddddddd");
		},
		closeCommunicationModal() {
			this.selectedCommunicationQues = {};
			this.showCommunicationModal = false;
		},
		openPreview(imageUrl) {
			this.previewImage = imageUrl;
			this.isImageModalOpen = true;
		},
		removeOptionImage(i, index) {
			this.optionPreviews.splice(index, 1, null);
			i.media = "";
			i.mediaValue = "";
			console.log(this.mcqquestion);
		},
		previewOptionfile(event, index) {
			const file = event.target.files[0];
			if (!file) return;

			const reader = new FileReader();
			const media = `optionMediaValue_${index}`;

			reader.onload = (e) => {
				let parts = file.name.split(".");
				let ext = parts[parts.length - 1];
				if (!isImage(ext)) {
					this.errorToast("Invalid media file");
					return;
				}
				// 1. Save key to media field for display reference
				this.mcqquestion.options[index].media = media;
				// 2. Store actual File in questions array using dynamic key
				this.mcqquestion[media] = file;

				// Optional: if you want preview in template
				// this.questions.options[index].mediaPreview = e.target.result;
				while (this.optionPreviews.length <= index) {
					this.optionPreviews.push(null);
				}

				// Replace at correct index
				this.optionPreviews.splice(index, 1, e.target.result);
				this.mcqquestion.options[index].value = "";
				this.$forceUpdate();
			};

			reader.readAsDataURL(file);

			// Clear input so same file can be re-uploaded
			event.target.value = "";
		},
		allowNumbers(event) {
			if (!/^\d$/.test(event.key)) {
				event.preventDefault();
			}
		},
		validateInput(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,3}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		filterQuestionTags(tags) {
			if (this.questagmore) return tags.slice(0, 6);
			else return tags;
		},
		hideDiffOptions() {
			this.qbdropdiff = false;
		},
		avoidNegativeAndOutOfRange(event) {
			if (
				event.key === "-" ||
				this.filter.marks.includes("-") ||
				event.key.toLowerCase() === "e"
			) {
				event.preventDefault();
			}
			const inputValue = parseInt(this.filter.marks + event.key);
			if (inputValue < 0 || inputValue > 100) {
				event.preventDefault();
			}
		},
		validateText(val) {
			this.dirtyMcqQuestion = val;
			this.dirtyMtfQuestion = val;
			this.dirtyLongQuestion = val;
		},
		filterFunction() {
			this.filtermodalshow = !this.filtermodalshow;
			this.$forceUpdate();
		},
		updateQuestionContent(newContent) {
			this.mcqquestion.question = newContent;
			this.matchquestion.question = newContent;
			this.longquestion.question = newContent;
		},
		changedaddQues(newval) {
			this.addquesMcq = newval;
			this.addquesMatch = newval;
			this.addquesLong = newval;
		},

		//For removing Space From Top and bottom of last text of Quill Editor
		getDesiredContent(contentType) {
			const tempDiv = document.createElement("div");
			let questionText = "";

			if (contentType === "mcqquestion") {
				questionText = this.mcqquestion.question;
			} else if (contentType === "matchquestion") {
				questionText = this.matchquestion.question;
			} else if (contentType === "longquestion") {
				questionText = this.longquestion.question;
			}
			tempDiv.innerHTML = questionText;

			const pTags = tempDiv.querySelectorAll("p");

			let endIndex = pTags.length;

			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}

			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});

			if (contentType === "mcqquestion") {
				this.mcqquestion.question = tempDiv.innerHTML;
			} else if (contentType === "matchquestion") {
				this.matchquestion.question = tempDiv.innerHTML;
			} else if (contentType === "longquestion") {
				this.longquestion.question = tempDiv.innerHTML;
			}
		},
		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		isImage,
		isVideo,
		isAudio,

		previewFileMCQ: function(event) {
			let mediaType = event.target.id;
			let input = event.target;
			if (input?.files?.[0]) {
				let reader = new FileReader();
				// FOR storing the FILE OBJECT value of a uploaded FILE
				// this.questions.questionMedia = input.files[0];

				reader.onload = (e) => {
					// FOR storing the binary value of a FILE
					this.mcqquestion.questionMedia = e.target.result;
					this.$forceUpdate();
				};
				reader.readAsDataURL(input.files[0]);

				// FOR getting the extension of a particular file
				let parts = input.files[0].name.split(".");
				let ext = parts[parts.length - 1];
				this.mcqquestion.questionMediaType = ext;

				// FOR Checking if the fileType is valid or NOT
				if (
					(mediaType == "file-upload-image" &&
						isImage(this.mcqquestion.questionMediaType)) ||
					(mediaType == "file-upload" &&
						isAudio(this.mcqquestion.questionMediaType)) ||
					(mediaType == "file-upload-video" &&
						isVideo(this.mcqquestion.questionMediaType))
				) {
					this.file = input.files[0];
					this.mcqquestion.isFailed = false;
					this.mcqquestion.file = this.file;
					this.mcqquestion.fileMeta = {
						name: this.file.name,
						size: this.file.size,
						type: this.file.type,
					};
					this.videoData = {
						name: this.file.name,
						size: this.file.size,
					};
					this.$bvModal.hide("attachdocs");
					this.checkMedia = true;
				} else {
					// FOR storing the FILE OBJECT Copy of the uploaded FILE
					this.mcqquestion.isFailed = true;
					this.checkMedia = false;
					this.file = "";
					delete this.mcqquestion.questionMedia;
					delete this.mcqquestion.questionMediaType;
				}
			}
			event.target.value = "";
		},
		checkDecimalMCQ() {
			if (!this.$v.mcqquestion.marks.$error) {
				let data = this.mcqquestion.marks.toString();
				let index = data.indexOf(".");
				if (index !== -1) {
					this.checkDec = data.split(".")[1].length > 2;
				}
			} else {
				this.checkDec = false;
			}
		},
		checkDecimalMTF() {
			if (!this.$v.matchquestion.marks.$error) {
				let data = this.matchquestion.marks.toString();
				let index = data.indexOf(".");
				if (index !== -1) {
					this.checkDec = data.split(".")[1].length > 2;
				}
			} else {
				this.checkDec = false;
			}
		},
		checkDecimalLONG() {
			if (!this.$v.longquestion.marks.$error) {
				let data = this.longquestion.marks.toString();
				let index = data.indexOf(".");
				if (index !== -1) {
					this.checkDec = data.split(".")[1].length > 2;
				}
			} else {
				this.checkDec = false;
			}
		},
		addTagAndResetInputMCQ() {
			if (this.tagmodal.trim() !== "") {
				this.mcqquestion.questionTags.push(this.tagmodal.trim());
				this.tagmodal = "";
				this.$forceUpdate();
			}
		},
		addTagAndResetInputMTF() {
			if (this.tagmodal.trim() !== "") {
				this.matchquestion.questionTags.push(this.tagmodal.trim());
				this.tagmodal = "";
				this.$forceUpdate();
			}
		},
		addTagAndResetInputLONG() {
			if (this.tagmodal.trim() !== "") {
				this.longquestion.questionTags.push(this.tagmodal.trim());
				this.tagmodal = "";
				this.$forceUpdate();
			}
		},
		previewFileMatch: function(event) {
			let mediaType = event.target.id;
			let input = event.target;
			if (input?.files?.[0]) {
				console.log("Previre Match");
				let reader = new FileReader();
				// FOR storing the FILE OBJECT value of a uploaded FILE
				// this.questions.questionMedia = input.files[0];

				reader.onload = (e) => {
					// FOR storing the binary value of a FILE
					this.matchquestion.questionMedia = e.target.result;
					this.$forceUpdate();
				};
				reader.readAsDataURL(input.files[0]);

				// FOR getting the extension of a particular file
				let parts = input.files[0].name.split(".");
				let ext = parts[parts.length - 1];
				this.matchquestion.questionMediaType = ext;

				// FOR Checking if the fileType is valid or NOT
				if (
					(mediaType == "file-upload-image" &&
						isImage(this.matchquestion.questionMediaType)) ||
					(mediaType == "file-upload" &&
						isAudio(this.matchquestion.questionMediaType)) ||
					(mediaType == "file-upload-video" &&
						isVideo(this.matchquestion.questionMediaType))
				) {
					this.file = input.files[0];
					this.matchquestion.file = this.file;
					this.matchquestion.fileMeta = {
						name: this.file.name,
						size: this.file.size,
						type: this.file.type,
					};
					this.videoData = {
						name: this.file.name,
						size: this.file.size,
					};
					this.matchquestion.isFailed = false;
					this.$bvModal.hide("attachdocs");
					this.checkMedia = true;
				} else {
					// FOR storing the FILE OBJECT Copy of the uploaded FILE
					this.matchquestion.isFailed = true;
					this.checkMedia = false;
					this.file = "";
					delete this.matchquestion.questionMedia;
					delete this.matchquestion.questionMediaType;
				}
			}
			event.target.value = "";
		},
		previewFileDesc: function(event) {
			let mediaType = event.target.id;
			let input = event.target;
			if (input?.files?.[0]) {
				let reader = new FileReader();
				// FOR storing the FILE OBJECT value of a uploaded FILE
				// this.questions.questionMedia = input.files[0];

				reader.onload = (e) => {
					// FOR storing the binary value of a FILE
					this.longquestion.questionMedia = e.target.result;
					this.$forceUpdate();
				};
				reader.readAsDataURL(input.files[0]);

				// FOR getting the extension of a particular file
				let parts = input.files[0].name.split(".");
				let ext = parts[parts.length - 1];
				this.longquestion.questionMediaType = ext;

				// FOR Checking if the fileType is valid or NOT
				if (
					(mediaType == "file-upload-image" &&
						isImage(this.longquestion.questionMediaType)) ||
					(mediaType == "file-upload" &&
						isAudio(this.longquestion.questionMediaType)) ||
					(mediaType == "file-upload-video" &&
						isVideo(this.longquestion.questionMediaType))
				) {
					this.file = input.files[0];
					this.longquestion.file = this.file;
					this.longquestion.fileMeta = {
						name: this.file.name,
						size: this.file.size,
						type: this.file.type,
					};
					this.videoData = {
						name: this.file.name,
						size: this.file.size,
					};
					this.longquestion.isFailed = false;
					this.$bvModal.hide("attachdocs-desc");
					this.checkMedia = true;
				} else {
					// FOR storing the FILE OBJECT Copy of the uploaded FILE
					this.longquestion.isFailed = true;
					this.checkMedia = false;
					this.file = "";
					delete this.longquestion.questionMedia;
					delete this.longquestion.questionMediaType;
				}
			}
			event.target.value = "";
		},
		previewData(index) {
			this.failedTests = this.force[index];
			this.$bvModal.show("preview-failed-modal");
		},
		async getquestionbank() {
			console.log("call");
			try {
				let payload = {
					page: this.currentPage - 1,
					count: this.question_count,
					filters: {
						QuesType: this.isCommunicationTestQB ? ["COMU"] : this.questionType,
						diffLevel: this.filter.difficulty_type,
						marks: this.filter.marks,
						questionTag: this.filter.questionTags,
						mediaType: this.selectedMediaType,
					},
					sortBy: {
						column: this.sortColumn,
						order: this.sorting,
					},
					searchQuery: this.searchTopicTestState,
				};
				const res = await getDataBank(payload);
				if (res.status == 200) {
					this.allQuestions = res.data.data.data;
					this.LoaderStatus = false;
					this.allQuestions.forEach((object) => {
						object.view = false;
					});
					this.pageStart = res.data.data.pageStart;
					this.pageEnd = res.data.data.pageEnd;
					this.total = res.data.data.total;
					this.checkSelectAll();
					this.totalPages = Math.ceil(
						parseInt(this.total) / parseInt(this.question_count)
					);
					const element = document.getElementById("top1");
					element.scrollTo({
						top: 0,
						behavior: "smooth",
					});
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		failedDeleteQuestion() {
			forcedeletemultiplequestions(this.selectedFailQuestions)
				.then((res) => {
					if (res.status == 200) {
						this.successToast(
							res.data.data.deleted.length +
								" Question deleted from question bank successfully!"
						);
						this.selectedFailQuestions = [];

						this.force.splice(this.selectedFailQuestions, 1);
						if (this.force.length == 0) {
							this.$bvModal.hide("delete-pass-fail");
						}
						this.getquestionbank();
					}
				})
				.catch((err) => {
					this.selectedFailQuestions = [];
					this.errorToast("Something went wrong");
					throw err;
				});
		},
		checkSelectAll() {
			let isSelectedAll = true;

			if (this.allQuestions.length === 0) {
				isSelectedAll = false;
			} else {
				for (let record of this.allQuestions) {
					if (
						this.selectedQuestions.filter(
							(value) => value === record.questionKey
						).length === 0
					) {
						isSelectedAll = false;
					}
				}
			}

			this.selectall = isSelectedAll;
		},
		filterapply() {
			this.LoaderStatus = true;
			this.storefilterdata = { ...this.filter };
			this.storeselectedMediaType = this.selectedMediaType;
			this.currentPage = 1;
			this.filtercount = 0;
			this.questionType = this.filter.questiontype_selected;
			if (this.filter.questiontype_selected.length != 0) {
				this.filtercount++;
			}
			if (this.filter.marks != "") {
				this.filtercount++;
			}
			if (this.filter.difficulty_type.length != 0) {
				this.filtercount++;
			}
			if (this.filter.questionTags.length != 0) {
				this.filtercount++;
			}
			if (this.selectedMediaType.length != 0) {
				this.filtercount++;
			}
			this.getquestionbank();
			this.filtermodalshow = false;
			this.qbdrop = false;
			this.showdiffoptions = false;
			this.questionTagOpen = false;
		},
		clearfilter() {
			this.LoaderStatus = true;
			this.currentPage = 1;
			this.filter = {
				marks: "",
				questiontype_selected: [],
				difficulty_type: [],
				questionTags: [],
			};
			this.storefilterdata = {
				questiontype_selected: [],
				marks: "",
				difficulty_type: [],
				questionTags: [],
			};
			this.selectedMediaType = [];
			this.storeselectedMediaType = [];
			this.questionType = ["MCQU", "MAFO", "LONG"];
			if (this.filtercount != 0) {
				this.getquestionbank();
			}
			this.filtercount = 0;
			this.filtermodalshow = false;
		},
		clearfilterbox() {
			this.filter = {
				marks: "",
				questiontype_selected: [],
				difficulty_type: [],
				questionTags: [],
			};
			this.storefilterdata = {
				questiontype_selected: [],
				marks: "",
				difficulty_type: [],
				questionTags: [],
			};
			this.selectedMediaType = [];
			this.storeselectedMediaType = [];
			this.questionType = ["MCQU", "MAFO", "LONG"];
			this.filtercount = 0;
		},
		viewQuestion(index) {
			this.allQuestions.forEach((object) => {
				object.view = false;
			});
			this.questagmore = true;
			this.allQuestions[index].view = true;
			this.allQuestions[index].questionTags = this.allQuestions[
				index
			].questionTags.map((s) =>
				s[0] != "#"
					? s.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1")
					: s
			);

			this.$forceUpdate();
		},
		closeViewQuestion(index) {
			this.allQuestions[index].view = false;
			this.$forceUpdate();
		},
		sort(data) {
			this.sortColumn = data;
			this.sorting = !this.sorting;
			this.getquestionbank();
		},
		removeExcelFile() {
			this.$refs["excel-upload-input"].value = null;
			this.excelFile = "";
			this.excelSheetNameShow = [];
			this.excelSheetName = [];
			this.singlesheets = "";
			this.$forceUpdate();
			this.showselecteddropdown = false;
		},
		removeExcelFromPopUp() {
			this.excelFile = "";
			this.excelSheetNameShow = [];
		},
		removeSheet(i) {
			this.excelSheetNameShow.splice(i, 1);
		},
		confirm() {
			this.check = false;
			console.log(this.selquestype);
			if (this.selquestype == "MCQ") {
				this.saveMcqbEdit();
			} else if (this.selquestype == "MTF") {
				this.saveMachEdit();
			} else if (this.selquestype == "LONG") {
				this.saveDescriptivebEdit();
			}
		},
		async getAllQuestionTag() {
			try {
				const res = await getAllQuestionTags();
				if (res.status == 200) {
					this.LoaderStatus = false;
					this.allQuestionTags = res.data.data.questionTags;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		getExcelTemplate() {
			getExcelTemplate()
				.then((res) => {
					const downloadLink = res.data.data.downloadLink;
					if (downloadLink) {
						this.downloadLink = downloadLink;
					}
				})
				.catch((err) => {
					throw err;
				});
		},
		download() {
			window.open(this.downloadLink);
		},

		// The pagination buttons functionality allow you to move backward and forward through the page
		goToPageNo(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			this.getquestionbank();
		},
		goToPageNum() {
			this.getquestionbank();
		},
		handleUpload() {
			this.$refs["excel-upload-input"].click();
		},
		rejectExcel() {
			this.$refs["excel-upload-input"].value = null;
		},
		acceptExcel() {
			let formData = new FormData();
			formData.append("excel", this.excelFile);
			if (this.singlesheets != "") {
				let arr = [];
				arr.push(this.singlesheets);
				formData.append("sheetName", JSON.stringify(arr));
			} else {
				formData.append("sheetName", JSON.stringify(this.excelSheetNameShow));
			}
			formData.append("questionType", this.downloadType);
			postExcel(formData).then((res) => {
				if (res.status == 200) {
					this.getquestionbank();
					this.successToast("Excel sheets uploaded successfully");
				} else if (res.status == 400) {
					this.errorToast(res.data.data.Detail);
				} else {
					this.errorToast(res.response.data.data.status);
				}
				this.$bvModal.hide("excel-modal-center");
			});
		},
		handleClick: function(event) {
			this.excelFile = event.target.files ? event.target.files[0] : null;
			if (this.excelFile) {
				const reader = new FileReader();

				reader.onload = (e) => {
					/* Parse data */
					const bstr = e.target.result;
					const wb = XLSX.read(bstr, { type: "binary" });
					if (wb.SheetNames.length == 1) {
						this.singlesheets = wb.SheetNames[0];
					} else {
						/* Get first worksheet */
						this.excelSheetName = wb.SheetNames;
					}

					this.SheetName = wb.SheetNames[0];
				};

				reader.readAsBinaryString(this.excelFile);
			}
		},

		scrollToRightMTF() {
			const scrollContainer = document.getElementById("mtfaddcontainer-tag");

			scrollContainer.scrollTo({
				top: 0,
				left: scrollContainer.scrollWidth,
				behavior: "smooth",
			});
		},
		addmtfquestiontag() {
			const el1 = document.getElementById("matchadd-tag");
			el1.addEventListener("click", this.scrollToRightMTF, false);
		},
		scrollToRightMCQ() {
			const scrollContainer = document.getElementById("mcqaddcontainer-tag");

			scrollContainer.scrollTo({
				top: 0,
				left: scrollContainer.scrollWidth,
				behavior: "smooth",
			});
		},
		addmcqquestiontag() {
			const el1 = document.getElementById("mcqadd-tag");
			el1.addEventListener("click", this.scrollToRightMCQ, false);
		},
		hashtagmcqadd() {
			let str = document.getElementById("mcq-add-tag").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("mcq-add-tag").value = tagged;
		},
		hashtagmatchadd() {
			let str = document.getElementById("match-add-tag").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("match-add-tag").value = tagged;
		},
		hashtaglongadd() {
			let str = document.getElementById("descriptive-add-tag").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("descriptive-add-tag").value = tagged;
		},
		resetModalMatch() {
			this.matchquestion.isFailed = false;
		},
		resetModalDescriptive() {
			this.longquestion.isFailed = false;
		},
		resetModalMCQ() {
			this.mcqquestion.isFailed = false;
		},
		simple() {
			this.filtermodalshow = false;
		},
		changequestagmore() {
			this.questagmore = !this.questagmore;
			this.$forceUpdate();
		},
		datemonthyear(date) {
			let yearNumber = parseInt(date.substring(0, 5));
			let monthNumber = parseInt(date.substring(6, 8));
			let dayNumber = parseInt(date.substring(9, 11));
			let result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
			return result;
		},
		closeattachdocsmodal() {
			this.$bvModal.hide("attachdocs");
		},
		closeattachdocsmatchmodal() {
			this.$bvModal.hide("attachdocs-match");
		},
		closeattachdocsdescmodal() {
			this.$bvModal.hide("attachdocs-desc");
		},
		modalpop() {
			if (!this.filtermodalshow) {
				this.getAllQuestionTag();
			}
			this.filtermodalshow = !this.filtermodalshow;
			this.filter = { ...this.storefilterdata };
			this.selectedMediaType = this.storeselectedMediaType;
			this.qbdrop = false;
			this.questionTagOpen = false;
			this.showdiffoptions = false;
		},
		killaddquestionmodal() {
			this.qbdropadd = false;
			this.$bvModal.hide("modal-center");
		},
		opendeltemodal() {
			this.$bvModal.show("modal-delete");
		},
		killmodaldelete() {
			this.$bvModal.hide("modal-delete");
		},
		killforcemodaldelete() {
			this.$bvModal.hide("force-delete");
		},
		editmodal(data) {
			if (data.questionTags.length > 0) {
				data.questionTags = data.questionTags.map((s) =>
					s[0] != "#"
						? s.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1")
						: s
				);
			}

			if (data.quesType == "MCQU") {
				this.handleMcqUpdate(data);
			} else if (data.quesType == "MAFO") {
				this.handleMtfUpdate(data);
			} else if (data.quesType == "LONG") {
				this.handleLongUpdate(data);
			}
		},
		killEditQuestion() {
			this.$bvModal.hide("modal-edit");
		},
		editmatchmodal() {
			this.$bvModal.show("modal-match");
		},
		killEditMatchQuestion() {
			this.$bvModal.hide("modal-match");
		},
		killaddmcqmodal() {
			this.closeAlLDirty();
			this.$bvModal.hide("modal-mcq-add");
		},
		killadddescriptivemodal() {
			this.closeAlLDirty();
			this.$bvModal.hide("modal-descriptive-add");
		},
		killaddmatchmodal() {
			this.closeAlLDirty();
			this.$bvModal.hide("modal-match-add");
		},

		closeAlLDirty() {
			this.dirtyLongQuestion = false;
			this.dirtyMcqQuestion = false;
			this.dirtyMtfQuestion = false;
			this.moreOption = false;
		},
		cancelmatchmedia() {
			this.matchquestion.questionMedia = "";
			this.matchquestion.questionMediaType = "";
			this.checkMedia = false;
			this.file = "";
			this.$forceUpdate();
		},
		cancelmcqmedia() {
			this.mcqquestion.questionMedia = "";
			this.mcqquestion.questionMediaType = "";
			this.checkMedia = false;
			this.file = "";
			this.$forceUpdate();
		},
		cancellongmedia() {
			this.longquestion.questionMedia = "";
			this.longquestion.questionMediaType = "";
			this.checkMedia = false;
			this.file = "";
			this.$forceUpdate();
		},

		// which Add modal need to open
		addQuestion() {
			if (this.addquestion == "MCQ") {
				this.handleMcqCreate();
			} else if (this.addquestion == "MTF") {
				this.handleMtfCreate();
			} else if (this.addquestion == "Descriptive") {
				this.handleDescriptiveCreate();
			}
		},
		handleMcqCreate() {
			this.resetMcqAddModal();
			this.mcqQuestionStatus = "Add";
			this.$bvModal.show("modal-mcq-add");
		},
		handleMtfCreate() {
			this.resetMatchAddModal();
			this.matchQuestionStatus = "Add";
			this.$bvModal.show("modal-match-add");
		},
		handleDescriptiveCreate() {
			this.resetDescriptiveAddModal();
			this.descriptiveQuestionStatus = "Add";
			this.$bvModal.show("modal-descriptive-add");
		},
		handleLongUpdate(data) {
			this.longquestion = JSON.parse(JSON.stringify(data));
			this.longquestion.questionType = "Descriptive";
			this.descriptiveQuestionStatus = "Edit";
			if (this.longquestion.questionMedia != null) {
				this.checkMedia = true;
			}
			this.$bvModal.show("modal-descriptive-add");
		},
		handleMcqUpdate(data) {
			this.mcqquestion = JSON.parse(JSON.stringify(data));
			let tick = 0;
			for (let i in this.mcqquestion.options) {
				if (this.mcqquestion.options[i].check) {
					tick += 1;
				}
			}
			if (tick == 0) {
				this.singletick = true;
				this.erroroption = true;
			} else {
				this.singletick = false;
				this.erroroption = false;
			}
			this.mcqquestion.questionType = "MCQ";
			this.mcqQuestionStatus = "Edit";
			if (this.mcqquestion.questionMedia != null) {
				this.checkMedia = true;
			}
			for (let i in this.mcqquestion.options) {
				if (this.mcqquestion.options[i].media) {
					this.optionPreviews = this.mcqquestion.options.map((opt) =>
						opt.media && opt.media !== "" ? opt.media : ""
					);
				}
			}
			this.$bvModal.show("modal-mcq-add");
		},
		handleMtfUpdate(data) {
			this.matchquestion = JSON.parse(JSON.stringify(data)); // copy obj
			this.matchquestion.questionType = "MTF";
			this.matchQuestionStatus = "Edit";
			if (this.matchquestion.questionMedia != null) {
				this.checkMedia = true;
			}
			this.$bvModal.show("modal-match-add");
		},
		addOptions() {
			if (this.mcqquestion.options.length >= 8) {
				this.moreOption = true;
			} else {
				this.moreOption = false;
			}
			if (!this.moreOption) {
				this.mcqquestion.options.push({
					value: "",
					media: "",
					check: false,
					mediaValue: "",
					preview: null,
				});
			}
			this.$nextTick(() => {
				const modalContent = this.$refs.mcqModalContent;
				if (modalContent) {
					const scrollToOptions = {
						top: modalContent.scrollHeight,
						behavior: "smooth",
					};

					modalContent.scrollTo(scrollToOptions);
				}
			});
		},
		addMatchOptions() {
			if (this.matchquestion.answerKey.length >= 8) {
				this.moreOption = true;
			} else {
				this.moreOption = false;
			}
			if (!this.moreOption) {
				this.matchquestion.answerKey.push({
					sideA: "",
					sideB: "",
				});
			}
			this.$nextTick(() => {
				const modalContent = this.$refs.mtfModalContent;
				if (modalContent) {
					const scrollToOptions = {
						top: modalContent.scrollHeight,
						behavior: "smooth",
					};

					modalContent.scrollTo(scrollToOptions);
				}
			});
		},
		async deleteOptions(index) {
			this.mcqquestion.options.splice(index, 1);
			this.optionPreviews.splice(index, 1); // Keep previews synced
			this.moreOption = false;
			this.$forceUpdate();
		},
		deletematchoptions(i) {
			this.matchquestion.answerKey.splice(i, 1);
			this.moreOption = false;
		},

		async addMcqQuestion() {
			try {
				this.showSpinner = true;
				this.cleanUpMcqTags();
				this.checkMcqOptions();

				this.$v.$touch();

				if (this.isMcqQuestionEmpty()) {
					this.dirtyMcqQuestion = true;
				}

				if (!this.singletick) {
					if (this.isValidMcqQuestion()) {
						this.mcqquestion.questionType = "MCQU";

						let bucketPath = null;

						//  ONLY ADD THIS
						if (this.mcqquestion.file && this.mcqquestion.fileMeta) {
							this.showVideoUploading = true;
							bucketPath = await this.uploadFileViaSocket(
								this.mcqquestion.file,
								this.mcqquestion.fileMeta
							);
						}
						const form = this.createMcqFormDataPayload(bucketPath);

						const res = await postMCQquestionv2(form);

						this.hideMcqModalsAndReset();
						if (res.status === 200) {
							this.handleMcqSuccess();
							this.showVideoUploading = false;
							this.videoData = {};
							this.progress = 0;
							this.showSpinner = false;
						}
					}
				}

				if (this.hasMcqValidationError()) {
					this.errorToast("Please fill all the mandatory fields");
				}
			} catch (error) {
				this.handleMcqException(error);
			}
		},

		cleanUpMcqTags() {
			if (this.mcqquestion.questionTags) {
				this.mcqquestion.questionTags = this.mcqquestion.questionTags.map((s) =>
					s[0] === "#" ? s.slice(1) : s
				);
			}
		},

		checkMcqOptions() {
			let single = 0;

			for (const option of this.mcqquestion.options) {
				if (option.check) {
					single += 1;
				}
			}

			this.singletick = single === 0;
			this.erroroption = single === 0;
		},

		isMcqQuestionEmpty() {
			return this.mcqquestion.question === "";
		},

		isValidMcqQuestion() {
			return !this.$v.mcqquestion.$invalid && !this.dirtyMcqQuestion;
		},

		createMcqFormDataPayload(bucketPath) {
			const form = new FormData();

			this.getDesiredContent("mcqquestion");

			for (const [key, value] of Object.entries(this.mcqquestion)) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key === "questionMedia") {
					this.handleMcqQuestionMedia(form, bucketPath);
				} else if (key === "options" || key === "questionTags") {
					this.handleMcqArrayField(key, form);
				} else {
					form.append(key, value);
				}
			}

			form.append("addToDatabank", true);

			return form;
		},

		handleMcqQuestionMedia(form, bucketPath) {
			if (
				this.file === "" &&
				this.mcqquestion.questionMedia === "" &&
				!bucketPath
			) {
				delete this.mcqquestion.questionMedia;
				delete this.mcqquestion.questionMediaType;
				form.set("delete", 1);
			} else if (
				this.file === "" &&
				this.mcqquestion.questionMedia !== "" &&
				!bucketPath
			) {
				// Do nothing (media unchanged)
			} else if (bucketPath) {
				form.append("questionMediaPath", bucketPath);
				form.append("questionMediaType", this.mcqquestion.questionMediaType);
			}
		},
		handleMcqArrayField(key, form) {
			this.mcqquestion[key] = JSON.stringify(this.mcqquestion[key]);
			form.append(key, this.mcqquestion[key]);
			this.mcqquestion[key] = JSON.parse(this.mcqquestion[key]);
		},

		handleMcqSuccess() {
			this.getquestionbank();
			this.LoaderStatus = false;
			this.successToast("Question added successfully to the question bank!");
		},

		hideMcqModalsAndReset() {
			this.$bvModal.hide("modal-mcq-add");
			this.$bvModal.hide("confirm-edit-modal");

			this.$v.$reset();
			this.addquesMcq = true;
		},

		hasMcqValidationError() {
			return this.$v.$error;
		},

		handleMcqException(error) {
			this.LoaderStatus = false;
			this.mcqquestion.questionType = "MCQU";
			this.errorToast("Something went wrong!");
			throw new Error(`Failed! Status:${error.status}`);
		},

		async addDescriptiveQuestion() {
			try {
				this.showSpinner = true;
				this.cleanUpTags();

				this.$v.$touch();

				if (this.isEmptyLongQuestion()) {
					this.dirtyLongQuestion = true;
				}

				if (this.isValidLongQuestion()) {
					let bucketPath = null;

					//  ONLY ADD THIS
					if (this.longquestion.file && this.longquestion.fileMeta) {
						this.showVideoUploading = true;
						bucketPath = await this.uploadFileViaSocket(
							this.longquestion.file,
							this.longquestion.fileMeta
						);
					}
					const form = this.createFormDataPayload(bucketPath);

					const res = await postCommonQuestionv2(form);

					if (res.status === 200) {
						this.handleSuccess();
						this.showVideoUploading = false;
						this.showSpinner = false;
						this.progress = 0;
						this.videoData = {};
					}

					this.hideModalsAndReset();
				}

				if (this.hasValidationError()) {
					this.errorToast("Please fill all the mandatory fields");
				}
			} catch (error) {
				this.handleException(error);
			}
		},
		cleanUpTags() {
			if (this.longquestion.questionTags) {
				this.longquestion.questionTags = this.longquestion.questionTags.map(
					(s) => (s[0] === "#" ? s.slice(1) : s)
				);
			}
		},

		isEmptyLongQuestion() {
			return this.longquestion.question === "";
		},

		isValidLongQuestion() {
			return !this.$v.longquestion.$invalid && !this.dirtyLongQuestion;
		},

		createFormDataPayload(bucketPath) {
			const form = new FormData();

			this.getDesiredContent("longquestion");

			for (const [key, value] of Object.entries(this.longquestion)) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key === "questionMedia") {
					this.handleQuestionMedialong(form, bucketPath);
				} else if (key === "questionTags") {
					this.handleQuestionTagslong(form);
				} else {
					form.append(key, value);
				}
			}

			form.append("addToDatabank", true);
			form.append("questionType", "LONG");

			return form;
		},

		handleQuestionMedialong(form, bucketPath) {
			if (
				this.file === "" &&
				this.longquestion.questionMedia === "" &&
				!bucketPath
			) {
				delete this.longquestion.questionMedia;
				delete this.longquestion.questionMediaType;
				form.set("delete", 1);
			} else if (
				this.file === "" &&
				this.longquestion.questionMedia !== "" &&
				!bucketPath
			) {
				// Do nothing
			} else if (bucketPath) {
				form.append("questionMediaPath", bucketPath);
				form.append("questionMediaType", this.longquestion.questionMediaType);
			}
		},

		handleQuestionTagslong(form) {
			this.longquestion.questionTags = JSON.stringify(
				this.longquestion.questionTags
			);
			form.append("questionTags", this.longquestion.questionTags);
			this.longquestion.questionTags = JSON.parse(
				this.longquestion.questionTags
			);
		},

		handleSuccess() {
			this.LoaderStatus = false;
			this.getquestionbank();
			this.check = true;
			this.successToast("Question added successfully to question bank!");
		},

		hideModalsAndReset() {
			this.$bvModal.hide("modal-descriptive-add");
			this.$bvModal.hide("confirm-edit-modal");
			this.$v.$reset();
			this.addquesLong = true;
		},

		hasValidationError() {
			return this.$v.$error;
		},

		handleException(error) {
			this.LoaderStatus = false;
			this.longquestion.questionType = "Descriptive";
			this.errorToast("Something went wrong!");
			throw new Error(`Failed! Status:${error.status}`);
		},

		icheck() {
			this.singletick = false;
			this.erroroption = false;
			// for (let j in this.mcqquestion.options) {
			//   if (this.mcqquestion.options[j].check) {
			//     this.mcqquestion.options[j].check = false;
			//   }
			// }
			// i.check = !i.check;
		},

		async addMatchQuestion() {
			try {
				this.showSpinner = true;
				this.cleanUpMatchTags();

				this.$v.$touch();

				if (this.isMatchQuestionEmpty()) {
					this.dirtyMtfQuestion = true;
				}

				if (this.isValidMatchQuestion()) {
					this.matchquestion.questionType = "MAFO";
					let bucketPath = null;

					//  ONLY ADD THIS
					if (this.matchquestion.file && this.matchquestion.fileMeta) {
						this.showVideoUploading = true;
						bucketPath = await this.uploadFileViaSocket(
							this.matchquestion.file,
							this.matchquestion.fileMeta
						);
					}
					const form = this.createMatchFormDataPayload(bucketPath);

					const res = await postMatchTheFollowingQuestionv2(form);

					if (res.status === 200) {
						this.handleMatchSuccess();
						this.showVideoUploading = false;
						this.showSpinner = false;
						this.progress = 0;
						this.videoData = {};
					}

					this.hideMatchModalsAndReset();
				}

				if (this.hasMatchValidationError()) {
					this.errorToast("Please fill all the mandatory fields");
				}
			} catch (error) {
				this.handleMatchException(error);
			}
		},

		cleanUpMatchTags() {
			if (this.matchquestion.questionTags) {
				this.matchquestion.questionTags = this.matchquestion.questionTags.map(
					(s) => (s[0] === "#" ? s.slice(1) : s)
				);
			}
		},

		isMatchQuestionEmpty() {
			return this.matchquestion.question === "";
		},

		isValidMatchQuestion() {
			return !this.$v.matchquestion.$invalid && !this.dirtyMtfQuestion;
		},

		createMatchFormDataPayload(bucketPath) {
			const form = new FormData();

			this.getDesiredContent("matchquestion");

			for (const [key, value] of Object.entries(this.matchquestion)) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key === "questionMedia") {
					this.handleMatchQuestionMedia(form, bucketPath);
				} else if (key === "answerKey" || key === "questionTags") {
					this.handleMatchArrayField(key, form);
				} else {
					form.append(key, value);
				}
			}

			form.append("addToDatabank", true);

			return form;
		},

		handleMatchQuestionMedia(form, bucketPath) {
			if (
				this.file === "" &&
				this.matchquestion.questionMedia === "" &&
				!bucketPath
			) {
				delete this.matchquestion.questionMedia;
				delete this.matchquestion.questionMediaType;
				form.set("delete", 1);
			} else if (
				this.file === "" &&
				this.matchquestion.questionMedia !== "" &&
				!bucketPath
			) {
				// Do nothing
			} else if (bucketPath) {
				this.showVideoUploading = true;
				form.append("questionMediaPath", bucketPath);
				form.append("questionMediaType", this.matchquestion.questionMediaType);
			}
		},

		handleMatchArrayField(key, form) {
			this.matchquestion[key] = JSON.stringify(this.matchquestion[key]);
			form.append(key, this.matchquestion[key]);
			this.matchquestion[key] = JSON.parse(this.matchquestion[key]);
		},

		handleMatchSuccess() {
			this.LoaderStatus = false;
			this.getquestionbank();
			this.check = true;
			this.successToast("Question added successfully to question bank!");
		},

		hideMatchModalsAndReset() {
			this.$bvModal.hide("modal-match-add");
			this.$bvModal.hide("confirm-edit-modal");
			this.$v.$reset();
			this.addquesMatch = true;
		},

		hasMatchValidationError() {
			return this.$v.$error;
		},

		handleMatchException(error) {
			this.LoaderStatus = false;
			this.matchquestion.questionType = "MAFO";
			this.errorToast("Something went wrong!");
			throw new Error(`Failed! Status:${error.status}`);
		},

		async saveMcqbEdit() {
			this.showSpinner = true;
			this.$v.$touch();
			await this.checkSingleOption();

			console.log(this.singletick);
			if (!this.singletick) {
				this.handleValidations();
				console.log(this.singleTick);
			}
		},

		checkSingleOption() {
			let single = 0;
			for (let i in this.mcqquestion.options) {
				if (this.mcqquestion.options[i].check) {
					single += 1;
				}
			}

			console.log("this.singleTick", single);
			this.singletick = single === 0;
		},

		async handleValidations() {
			console.log("handle validation");
			if (this.$v.mcqquestion.$invalid || this.dirtyMcqQuestion) {
				this.errorToast("Please fill all the mandatory fields");
			} else if (!this.$v.mcqquestion.$invalid) {
				await this.createFormData();
			}
		},

		async createFormData() {
			let form = new FormData();

			let questionDataWithTags = { ...this.mcqquestion };

			questionDataWithTags.questionTags = this.addHashSymbolToTags(
				questionDataWithTags.questionTags
			);

			this.getDesiredContent("mcqquestion");

			for (let key in questionDataWithTags) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key === "questionMedia") {
					await this.handleQuestionMedia(form, questionDataWithTags);
				} else if (key === "options") {
					this.handleOptions(form, questionDataWithTags);
				} else if (key === "questionTags") {
					this.handleQuestionTags(form, questionDataWithTags);
				} else {
					form.append(key, questionDataWithTags[key]);
				}
			}

			form.append("check", this.check);
			this.handlePutMCQRequest(form);
			this.showVideoUploading = false;
			this.showSpinner = false;
			this.progress = 0;
			this.videoData = {};
		},

		addHashSymbolToTags(tags) {
			return tags.map((tag) => (tag[0] === "#" ? tag : "#" + tag));
		},
		async uploadIfNeeded() {
			if (!this.file || !this.mcqquestion.fileMeta) return null;

			return await this.uploadFileViaSocket(
				this.file,
				this.mcqquestion.fileMeta
			);
		},
		async uploadmtfIfNeeded() {
			if (!this.file || !this.matchquestion.fileMeta) return null;

			return await this.uploadFileViaSocket(
				this.file,
				this.matchquestion.fileMeta
			);
		},
		async uploadlongIfNeeded() {
			if (!this.file || !this.longquestion.fileMeta) return null;

			return await this.uploadFileViaSocket(
				this.file,
				this.longquestion.fileMeta
			);
		},
		async handleQuestionMedia(form, questionDataWithTags) {
			//  Media removed (EDIT)
			if (this.file === "" && questionDataWithTags.questionMedia === "") {
				this.handleEmptyQuestionMedia(form, questionDataWithTags);
				return;
			}

			// Media unchanged (EDIT)
			if (this.file === "" && questionDataWithTags.questionMedia !== "") {
				return;
			}

			//  Media added (ADD or EDIT re-add)
			if (this.file) {
				this.showVideoUploading = true;
				const bucketPath = await this.uploadIfNeeded();
				if (bucketPath) {
					form.append("questionMediaPath", bucketPath);
					form.append(
						"questionMediaType",
						questionDataWithTags.questionMediaType
					);
				}
				return;
			}
		},
		handleEmptyQuestionMedia(form, questionDataWithTags) {
			delete questionDataWithTags.questionMedia;
			delete questionDataWithTags.questionMediaType;
			form.set("delete", 1);
		},

		handleOptions(form, questionDataWithTags) {
			questionDataWithTags.options = JSON.stringify(
				questionDataWithTags.options
			);
			form.append("options", questionDataWithTags.options);
			questionDataWithTags.options = JSON.parse(questionDataWithTags.options);
		},

		handleQuestionTags(form, questionDataWithTags) {
			questionDataWithTags.questionTags = JSON.stringify(
				this.removeHashSymbolFromTags(questionDataWithTags.questionTags)
			);
			form.append("questionTags", questionDataWithTags.questionTags);
			questionDataWithTags.questionTags = JSON.parse(
				questionDataWithTags.questionTags
			);
		},

		removeHashSymbolFromTags(tags) {
			return tags.map((tag) => (tag[0] === "#" ? tag.slice(1) : tag));
		},

		handlePutMCQRequest(form) {
			putMCQquestionv2(form)
				.then((res) => {
					this.handlePutSuccess(res);
				})
				.catch((err) => {
					this.handlePutError(err);
				})
				.finally(() => {
					this.LoaderStatus = false;
					this.$v.$reset();
				});
		},

		handlePutSuccess(res) {
			if (res.status === 200) {
				this.updateQuestionAndDisplaySuccessToast();
				this.$bvModal.hide("modal-mcq-add");
				this.$bvModal.hide("confirm-edit-modal");
				this.getquestionbank();
			} else if (res.status === 409) {
				this.showConflictModal();
				// this.$bvModal.hide("modal-mcq-add");
				// this.$bvModal.hide("confirm-edit-modal");
			}
		},
		updateQuestionAndDisplaySuccessToast() {
			const updatedAt = new Date();
			this.mcqquestion.updatedAt = updatedAt.toISOString();

			let index = this.allQuestions.findIndex(
				(i) => i.questionKey === this.mcqquestion.questionKey
			);

			if (index > -1) {
				this.allQuestions.splice(index, 1, this.mcqquestion);
			}

			this.addquesMcq = false;
			this.dirtyMcqQuestion = false;
			this.successToast("Question updated successfully!");
		},

		showConflictModal() {
			this.selquestype = "MCQ";
			this.$bvModal.show("confirm-edit-modal");
		},
		async saveDescriptivebEdit() {
			try {
				this.showVideoUploading = true;
				this.showSpinner = true;
				// Store the question data with '#' symbols for tags in a separate variable
				let questionDataWithTags = { ...this.longquestion };

				questionDataWithTags.questionTags = questionDataWithTags.questionTags.map(
					(s) => (s[0] == "#" ? s : "#" + s)
				);

				this.$v.$touch();
				// Checks FOR the validations
				delete questionDataWithTags.questionType;
				if (this.$v.longquestion.$invalid || this.dirtyLongQuestion) {
					this.errorToast("Please fill all the mandatory fields");
				} else if (!this.$v.longquestion.$invalid) {
					let form = new FormData();

					this.getDesiredContent("longquestion");
					// FOR Creating the FORM data a payload for sending FILE UPLOAD data
					await this.handleDescEdit(questionDataWithTags, form);
					form.append("check", this.check);
					form.append("addToDatabank", true);
					form.append("questionType", "LONG");
					const res = await putCommonQuestionv2(form);
					if (res.status == 200) {
						this.$bvModal.hide("confirm-edit-modal");

						const updatedAt = new Date();
						this.longquestion.updatedAt = updatedAt.toISOString();

						this.check = true;
						let index = this.allQuestions.findIndex(
							(i) => i.questionKey === this.longquestion.questionKey
						);

						if (index > -1) {
							this.allQuestions.splice(index, 1, this.longquestion);
						}
						this.addquesLong = false;
						this.dirtyLongQuestion = false;
						this.successToast(
							"Question updated successfully to the question bank!"
						);
						this.showVideoUploading = false;
						this.showSpinner = false;
						this.progress = 0;
						this.videoData = {};
					} else if (res.status == 409) {
						this.LoaderStatus = false;
						this.selquestype = "LONG";
						this.$bvModal.show("confirm-edit-modal");
					}
					this.$bvModal.hide("modal-descriptive-add");
					this.$v.$reset();
				}
			} catch (error) {
				this.longquestion.questionType = "Descriptive";
				if (error.response.status == 409) {
					this.selquestype = "LONG";
					this.$bvModal.show("confirm-edit-modal");
					this.LoaderStatus = false;
				} else {
					this.errorToast("Something went wrong!");
					this.LoaderStatus = false;
				}
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		async handleDescEdit(questionDataWithTags, form) {
			for (const key in questionDataWithTags) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key === "questionMedia") {
					await this.handleDescQuestionMedia(form, questionDataWithTags);
				} else if (key === "questionTags") {
					this.handleDescQuestionTags(form, questionDataWithTags);
				} else {
					form.append(key, questionDataWithTags[key]);
				}
			}
		},

		async handleDescQuestionMedia(form, questionDataWithTags) {
			if (this.file === "" && questionDataWithTags.questionMedia === "") {
				delete questionDataWithTags.questionMedia;
				delete questionDataWithTags.questionMediaType;
				form.set("delete", 1);
			} else if (
				this.file === "" &&
				questionDataWithTags.questionMedia !== ""
			) {
				return;
			}
			if (this.file) {
				this.showVideoUploading = true;
				const bucketPath = await this.uploadlongIfNeeded();
				if (bucketPath) {
					form.append("questionMediaPath", bucketPath);
					form.append(
						"questionMediaType",
						questionDataWithTags.questionMediaType
					);
				}
				return;
			}
		},

		handleDescQuestionTags(form, questionDataWithTags) {
			questionDataWithTags.questionTags = JSON.stringify(
				questionDataWithTags.questionTags.map((tag) =>
					tag[0] === "#" ? tag.slice(1) : tag
				)
			);
			form.append("questionTags", questionDataWithTags.questionTags);
			questionDataWithTags.questionTags = JSON.parse(
				questionDataWithTags.questionTags
			);
		},
		async saveMachEdit() {
			this.showSpinner = true;
			const questionDataWithTags = { ...this.matchquestion };
			questionDataWithTags.questionTags = questionDataWithTags.questionTags.map(
				(s) => (s[0] == "#" ? s : "#" + s)
			);
			this.$v.$touch();
			this.hadnlematcheditinvalid();

			const form = new FormData();
			this.getDesiredContent("matchquestion");

			if (!this.$v.matchquestion.$invalid) {
				await this.handleMatchEdit(questionDataWithTags, form);
				form.append("check", this.check);

				try {
					await this.handleSaveRequest(form);
				} catch (error) {
					console.log(error);

					this.errorToast("Something went wrong!");
				}
			}
		},

		async handleMatchEdit(questionDataWithTags, form) {
			for (const [key, value] of Object.entries(questionDataWithTags)) {
				if (key === "questionFile" || key === "file" || key === "fileMeta") {
					continue;
				}
				if (key === "questionMedia") {
					if (this.file === "" && value === "") {
						delete questionDataWithTags.questionMedia;
						delete questionDataWithTags.questionMediaType;
						form.set("delete", 1);
						continue;
					} else if (this.file === "" && value !== "") {
						continue;
					}

					if (this.file) {
						this.showVideoUploading = true;
						const bucketPath = await this.uploadmtfIfNeeded();
						if (bucketPath) {
							form.append("questionMediaPath", bucketPath);
							form.append(
								"questionMediaType",
								questionDataWithTags.questionMediaType
							);
						}
						continue;
					}
				} else if (key === "answerKey" || key === "questionTags") {
					form.append(key, JSON.stringify(value));
				} else {
					form.append(key, value);
				}
			}
		},

		hadnlematcheditinvalid() {
			if (this.$v.matchquestion.$invalid) {
				this.errorToast("Enter all the details");
			}
		},
		async handleSaveRequest(form) {
			const res = await putMatchTheFollowingQuestionv2(form);

			if (res.status === 200) {
				this.MatchEditSucess();
				this.showVideoUploading = false;
				this.showSpinner = false;
				this.progress = 0;
				this.videoData = {};
			} else if (res.status === 409) {
				this.selquestype = "MTF";
				this.$bvModal.show("confirm-edit-modal");
			}
			// Add more specific error handling if needed
		},

		MatchEditSucess() {
			this.LoaderStatus = false;
			this.$bvModal.hide("modal-match-add");
			this.$bvModal.hide("confirm-edit-modal");
			const updatedAt = new Date();
			this.matchquestion.updatedAt = updatedAt.toISOString();
			this.check = true;
			let index = this.allQuestions.findIndex(
				(i) => i.questionKey === this.matchquestion.questionKey
			);

			if (index > -1) {
				this.allQuestions.splice(index, 1, this.matchquestion);
			}
			this.addquesMatch = false;
			this.dirtyMtfQuestion = false;
			this.successToast("Question updated successfully!");
		},

		selectAll() {
			if (this.selectall) {
				for (let i in this.allQuestions) {
					if (
						this.selectedQuestions.filter(
							(value) => value == this.allQuestions[i].questionKey
						).length === 0
					) {
						this.selectedQuestions.push(this.allQuestions[i].questionKey);
					}
				}
			} else {
				for (let j in this.allQuestions) {
					if (
						this.selectedQuestions.filter(
							(value) => value == this.allQuestions[j].questionKey
						).length > 0
					) {
						this.selectedQuestions.splice(
							this.selectedQuestions.indexOf(this.allQuestions[j].questionKey),
							1
						);
					}
				}
			}
		},

		deselect() {
			this.selectall = false;

			const containsAll = this.allQuestions.every((element) => {
				return this.selectedQuestions.includes(element.questionKey);
			});
			if (containsAll) {
				this.selectall = true;
			}
		},
		questionTagToggle() {
			this.questionTagOpen = !this.questionTagOpen;
		},
		deleteQuestions() {
			this.LoaderStatus = true;
			let payload = {
				questions: this.selectedQuestions,
			};
			deleteMultipleQuestion(payload)
				.then((res) => {
					if (res.status == 200) {
						this.LoaderStatus = false;
						this.force = res.data.data.issues;
						this.deleted = res.data.data.deleted;
						if (this.force.length != 0) {
							this.errorToast(
								this.force.length +
									" Questions failed to delete from question bank"
							);
							this.getquestionbank();
						} else if (res.data.data.deleted.length != 0) {
							this.successToast(
								this.deleted +
									" Question deleted from question bank successfully!"
							);
							this.getquestionbank();
						}
						if (this.force.length != 0) {
							this.LoaderStatus = true;
							this.$bvModal.show("delete-pass-fail");
						}
					}
				})
				.catch((err) => {
					this.LoaderStatus = false;
					this.errorToast("Something went wrong");
					throw err;
				})
				.finally(() => {
					this.selectedQuestions = [];
					this.selectall = false;
				});

			this.$bvModal.hide("modal-delete");
		},

		//reset selected question modal values
		resetAddQuestionModal() {
			this.addquestion = "";
			this.dirtyMcqQuestion = false;
			this.dirtyMtfQuestion = false;
			this.dirtyLongQuestion = false;
		},
		resetMcqAddModal() {
			this.checkMedia = false;
			this.singletick = true;
			this.tagmodal = "";
			this.mcqquestion = {
				question: "",
				questionType: "MCQ",
				options: [
					{
						value: "",
						media: "",
						check: false,
					},
					{
						value: "",
						media: "",
						check: false,
					},
				],
				difficultyLevel: "",
				required: false,
				autoCorrection: false,
				marks: "",
				addToPublic: false,
				topic: "abc",
				questionMedia: "",
				questionMediaType: "",
				isFailed: false,
			};
			this.moreOption = false;
			this.qbdropdiff = false;
			this.erroroption = false;
			this.optionPreviews = [];
			this.dirtyMcqQuestion = false;
			this.$v.$reset();
			console.log(this.mcqquestion, "mcqqu");
		},
		resetDescriptiveAddModal() {
			this.checkMedia = false;
			this.tagmodal = "";
			this.longquestion = {
				question: "",
				questionType: "Descriptive",
				difficultyLevel: "",
				required: false,
				autoCorrection: false,
				marks: "",
				addToPublic: false,
				topic: "abc",
				questionMedia: "",
				questionMediaType: "",
				isFailed: false,
			};
			this.qbdropdiff = false;
			this.dirtyLongQuestion = false;
			this.$v.$reset();
		},
		resetMatchAddModal() {
			this.checkMedia = false;
			this.moreOption = false;
			this.tagmodal = "";
			this.matchquestion = {
				question: "",
				questionType: "MTF",
				answerKey: [
					{
						sideA: "",
						sideB: "",
					},
					{
						sideA: "",
						sideB: "",
					},
					{
						sideA: "",
						sideB: "",
					},
				],
				difficultyLevel: "",
				required: false,
				autoCorrection: false,
				marks: "",
				addToPublic: false,
				topic: "abc",
				questionMedia: "",
				questionMediaType: "",
				isFailed: false,
			};
			this.qbdropdiff = false;
			this.dirtyMtfQuestion = false;
			this.$v.$reset();
		},
	},
};
</script>

<style>

.custom-control-label::after {
	cursor: pointer;
}

.tagged-test-qb {
	height: calc(100vh - 250px);
	overflow: auto;
	padding-right: 5px;
}

.failQuestionCheckbox {
	margin-left: 20px;
}

.filterMedia {
	font-size: 13px;
	color: #72738e;
}

.taggedTo {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
	/* identical to box height */

	color: #72738e;
}

.taggedTestData {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	line-height: 21px;
	/* identical to box height */

	text-decoration-line: underline;

	color: #72738e;
}

.failedQuestionData {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	color: #72738e;
	padding: 4px;
}

.failedQuestion {
	box-sizing: border-box;
	height: 75px;

	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	margin-top: 20px;
}

.qb-dynamicGrid {
	width: 4px;
	height: 70px;
	border-radius: 5px;
	background-color: #ff4752;
	margin-top: -23px;
	margin-left: 1px;
}

.deleted-questions-body {
	height: 390px;
}

.deleted-main-container {
	min-height: auto;
	max-height: 550px;
	overflow: auto;
}

.Preview-data {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 21px;
	padding: 5px;

	color: #696969;
}

.test-name {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;

	color: #333333;
	padding: 5px;
}

.Preview-heading {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 15px;
	color: #72738e;
	padding: 5px;
}

.Preview-box {
	background: #ffffff;
	border: 0.5px solid #c4c4c4;
	box-shadow: 0px 0px 5px rgba(86, 86, 86, 0.2);
	border-radius: 5px;
	overflow: auto;
}

.sbox-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #565656;
}

.selectedsheet-box {
	margin: 3px;
	padding: 5px 10px;
	background: #f1f1f1;
}

.selectedsheet-text {
	font-weight: 500;
	font-size: 12px;
	color: #72738e;
}

.aoeinput .form-control {
	padding: 0.375rem 1.3rem !important;
}

.aoesearchicon-pos {
	position: absolute;
	top: 5px;
	left: 5px;
}

.dropdown-container {
	padding: 5px 15px;
	background: #ffffff;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
}

.uploadfile-head-text {
	font-weight: 400;
	font-size: 13px;
	color: #565656;
}

.slectedsheet-container {
	background: #ffffff;
	border: 1px solid #f1f1f1;
	border-radius: 5px;
	padding: 10px;
	overflow-x: hidden;
}

/* this class will be applied when the dropdown of choose sheets will be closed */
.slectedsheet-container-forDropdown {
	background: #ffffff;
	border: 1px solid #f1f1f1;
	border-radius: 5px;
	padding: 10px;
	min-height: auto;
	max-height: calc(100vh - 500px);
	overflow-x: hidden;
	overflow-y: auto;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
	background-color: #fcfcfc;
	border-radius: 3px;
	border-color: unset;
	color: #72738e;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-secondary.dropdown-toggle:focus {
	box-shadow: unset;
}

.onclickcolor {
	color: blue;
}

input[type="file"] {
	display: none;
}

.qb-filter-count-ex {
	position: absolute;
	left: 18px;
	top: -5px;
	width: 19px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-right: 1px;
}

.new-margin {
	margin-left: 55px;
}

.new-padding {
	padding: 10px;
}

.upload-question-table {
	height: 75px;
	border: 0.5px solid #e5e5e5;
	box-sizing: border-box;
	background: #fcfcfc;
	box-shadow: 0px 4px 12px rgba(196, 196, 196, 0.5);
	margin: 8px 0px 8px 0px;
	width: 99.5%;
	display: table;
	border-radius: 5px;
	table-layout: fixed;
}

.failed-questions-preview {
	background: #f3f3f3;
	border-radius: 5px 5px 0px 0px;
}

.question-tagged {
	font-family: "Open Sans", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;

	color: #545454;
}

.fail-pass-questions {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 11px;

	color: #72738e;
}

.failed-delete {
	position: relative;
	bottom: 31px;
}

.mcq-top-card {
	position: relative;
	top: -12px;
	left: 14px;
	background: #f5f5f5;
	border-radius: 3px;
	font-size: var(--size-12);
	color: var(--cv-headcolor);
	font-weight: var(--weight-M);
	height: 24px;
	width: 60px;
	padding-left: 16px;
	padding-right: 8px;
	padding-top: 1px;
}

.del-ques-status {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	color: #72738e;
}

.qb-gridgreencolorDynamic {
	width: 4px;
	height: 12%;
	border-radius: 2px;
	position: absolute;
	margin-top: -22px;
}

.ques-new-text {
	word-break: break-all;
	color: #696969;
	font-size: 12px;
}

.qb-filter-modal-1 {
	position: absolute;
	width: 350px;
	height: 405px;
	top: 88px;
	right: 118px;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	z-index: 6;
}

.qb-dropdown-option-add-1 {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	margin-top: 3px;
	padding: 10px;
	position: absolute;
	z-index: 7;
	width: 100%;
	font-size: var(--size-13);
	color: #545454;
}

.qb-dropdown-option-add {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	margin-top: 3px;
	padding: 10px;
	position: absolute;
	z-index: 7;
	width: 90%;
	font-size: var(--size-13);
	color: #545454;
}

.btn:focus,
.btn.focus {
	outline: 0;
	box-shadow: unset;
}

/* select a sheet label design */
.section-text-selectsheet {
	background: var(--bg-white);
	position: absolute;
	font-size: var(--size-12);
	color: var(--btn-border);
	font-weight: var(--weight-LM);
	left: 12px;
	bottom: 33px;
	padding-left: 5px;
	padding-right: 5px;
}

/* height adjustment for dropdown in import excel */
.height-adjustment-container {
	min-height: 85px;
	max-height: calc(100vh - 630px);
	overflow: auto;
}

.qb-blue-parent .form-control {
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5) !important;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
}

.qb-transparent .form-control {
	background: transparent;
	border: none !important;
	box-shadow: none;
}

/* table new design style starts here */
.question-main-table {
	width: 100%;
	position: relative;
	height: calc(100vh - 126px);
	overflow-x: auto;
	overflow-y: hidden;
}

.question-table-head {
	min-width: 1000px;
	max-width: 100%;
	background-color: #72738e;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 10px 0px;
	color: #fff;
	font-size: 14px;
	font-weight: 500;
}

.question-table-body {
	min-width: 1000px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 235px);
}

.question-table-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	border: 0.5px solid #e5e5e5;
	background: #fafafa;
	box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 10px 0px;
	margin: 20px 0px;
}

.question-table-row:hover {
	background: #e7e8f5;
}

.qbpaginaTion {
	min-width: 1000px;
	max-width: 100%;
	padding: 5px 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}

.question-view-card {
	background: #ebf5fe;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	width: 100%;
	position: relative;
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 10px 0px;
	margin: 20px 0px;
}

.questioncolorbar-match {
	width: 4px;
	background: #5aa0c2;
	border-radius: 2px;
	position: absolute;
	height: 90%;
	top: 5px;
	left: 5px;
}

.questioncolorbar-mcq {
	width: 4px;
	background: #3dd695;
	border-radius: 2px;
	position: absolute;
	height: 90%;
	top: 5px;
	left: 5px;
}

.questioncolorbar-desc {
	width: 4px;
	background: #d292f0;
	border-radius: 2px;
	position: absolute;
	height: 90%;
	top: 5px;
	left: 5px;
}
.questioncolorbar-comu {
	width: 4px;
	background: rgb(189, 199, 81);
	border-radius: 2px;
	position: absolute;
	height: 90%;
	top: 5px;
	left: 5px;
}

.question-expand-colorbar {
	width: 4px;
	border-radius: 2px;
	position: absolute;
	height: 100%;
	top: 0px;
	left: 5px;
}

.question-first-col {
	width: 5%;
}

.question-second-col {
	width: 43%;
}

.question-third-col {
	width: 13%;
}

.question-tag-name-view {
	position: absolute;
	top: -15px;
	left: 22px;
	background: #ffffff;
	border: 1px solid #dadada;
	border-radius: 3px;
	font-size: var(--size-12);
	color: var(--cv-headcolor);
	font-weight: var(--weight-M);
	height: 24px;
	width: 60px;
}

.marks-delete-icon {
	padding-right: 7px;
	padding-left: 5px;
	position: absolute;
	top: 5px;
	right: 28px;
	background: rgb(255, 255, 255);
}

/* table new design style ends here */

.question-image-container {
	width: 286px;
	height: 286px;
	background: rgba(32, 99, 155, 0.1);
	border-radius: 5px;
	overflow: hidden;
}
</style>
